(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './kotlinx-coroutines-core.js', './compose-multiplatform-core-compose-ui-ui-text.js', './compose-multiplatform-core-compose-foundation-foundation.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './skiko-kjs.js', './kotlinx-browser.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./kotlinx-coroutines-core.js'), require('./compose-multiplatform-core-compose-ui-ui-text.js'), require('./compose-multiplatform-core-compose-foundation-foundation.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./skiko-kjs.js'), require('./kotlinx-browser.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-ui-ui-text' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-text' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'components-resources-library'.");
    }
    if (typeof globalThis['kotlinx-browser'] === 'undefined') {
      throw new Error("Error loading module 'components-resources-library'. Its dependency 'kotlinx-browser' was not found. Please, check whether 'kotlinx-browser' is loaded prior to 'components-resources-library'.");
    }
    globalThis['components-resources-library'] = factory(typeof globalThis['components-resources-library'] === 'undefined' ? {} : globalThis['components-resources-library'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['kotlinx-coroutines-core'], globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['compose-multiplatform-core-compose-foundation-foundation'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['skiko-kjs'], globalThis['kotlinx-browser']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_compose_ui_ui_text, kotlin_org_jetbrains_compose_foundation_foundation, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_skiko_skiko, kotlin_org_jetbrains_kotlinx_kotlinx_browser) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var BitmapPainter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var endsWith = kotlin_kotlin.$_$.vj;
  var rememberVectorPainter = kotlin_org_jetbrains_compose_ui_ui.$_$.e1;
  var get_LocalDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.t6;
  var ImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a1;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var Builder = kotlin_org_jetbrains_compose_ui_ui.$_$.b1;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var lazy = kotlin_kotlin.$_$.to;
  var androidx_compose_ui_graphics_painter_Painter$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var Enum = kotlin_kotlin.$_$.en;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var toString = kotlin_kotlin.$_$.hh;
  var hashCode = kotlin_kotlin.$_$.bg;
  var equals = kotlin_kotlin.$_$.sf;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var CoroutineStart_LAZY_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n;
  var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h3;
  var Mutex = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o2;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var toList = kotlin_kotlin.$_$.kc;
  var first = kotlin_kotlin.$_$.o9;
  var joinToString = kotlin_kotlin.$_$.aa;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var emptyList = kotlin_kotlin.$_$.c9;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var Collection = kotlin_kotlin.$_$.y6;
  var minus = kotlin_kotlin.$_$.za;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui_text.$_$.j3;
  var isSystemInDarkTheme = kotlin_org_jetbrains_compose_foundation_foundation.$_$.p2;
  var compareValues = kotlin_kotlin.$_$.ad;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var split = kotlin_kotlin.$_$.cl;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.i4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var substringBefore = kotlin_kotlin.$_$.ml;
  var substringAfter = kotlin_kotlin.$_$.il;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var Default_getInstance = kotlin_kotlin.$_$.r2;
  var decodeToString = kotlin_kotlin.$_$.pj;
  var to = kotlin_kotlin.$_$.ip;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var split_0 = kotlin_kotlin.$_$.bl;
  var last = kotlin_kotlin.$_$.na;
  var toInt = kotlin_kotlin.$_$.yl;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  var equals_0 = kotlin_kotlin.$_$.wj;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var removeSuffix = kotlin_kotlin.$_$.sk;
  var toDouble = kotlin_kotlin.$_$.vl;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m4;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p4;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q4;
  var startsWith = kotlin_kotlin.$_$.dl;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var substring = kotlin_kotlin.$_$.ol;
  var toUInt = kotlin_kotlin.$_$.gm;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.o1;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r4;
  var isBlank = kotlin_kotlin.$_$.dk;
  var filter = kotlin_kotlin.$_$.dj;
  var Sequence = kotlin_kotlin.$_$.bj;
  var sequence = kotlin_kotlin.$_$.hj;
  var addPathNodes = kotlin_org_jetbrains_compose_ui_ui.$_$.c1;
  var PathFillType = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i1;
  var StrokeCap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r1;
  var StrokeJoin = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s1;
  var get_EmptyPath = kotlin_org_jetbrains_compose_ui_ui.$_$.a1;
  var removeLastOrNull = kotlin_kotlin.$_$.nb;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var Companion_instance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e4;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var TileMode = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.t1;
  var toList_0 = kotlin_kotlin.$_$.ij;
  var checkIndexOverflow = kotlin_kotlin.$_$.a8;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var Color_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var SequenceScope = kotlin_kotlin.$_$.aj;
  var until = kotlin_kotlin.$_$.mi;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var convertToInt = kotlin_kotlin.$_$.le;
  var add = kotlin_kotlin.$_$.fe;
  var sliceArray = kotlin_kotlin.$_$.vb;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var Companion_getInstance_5 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d4;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var Companion_getInstance_6 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var Companion_getInstance_7 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j4;
  var CanvasDrawScope = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var Canvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var FontStyle = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b;
  var Companion_getInstance_8 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b3;
  var Companion_getInstance_9 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.y2;
  var FontVariation_instance = kotlin_org_jetbrains_compose_ui_ui_text.$_$.a3;
  var _FontStyle___get_value__impl__gx8aaz = kotlin_org_jetbrains_compose_ui_ui_text.$_$.d2;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var sorted = kotlin_kotlin.$_$.zb;
  var lastOrNull = kotlin_kotlin.$_$.ja;
  var Font = kotlin_org_jetbrains_compose_ui_ui_text.$_$.d1;
  var FontStyle__toString_impl_thncxr = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c2;
  var SystemFont_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c4;
  var Companion_getInstance_10 = kotlin_org_jetbrains_skiko_skiko.$_$.j;
  var SVGDOM_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.t4;
  var Companion_getInstance_11 = kotlin_org_jetbrains_skiko_skiko.$_$.n;
  var Companion_instance_1 = kotlin_org_jetbrains_skiko_skiko.$_$.q;
  var Companion_getInstance_12 = kotlin_org_jetbrains_skiko_skiko.$_$.u;
  var Paint_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.a5;
  var Companion_getInstance_13 = kotlin_org_jetbrains_skiko_skiko.$_$.r;
  var toComposeImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q2;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var SVGLengthUnit_PX_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.u1;
  var SVGLength = kotlin_org_jetbrains_skiko_skiko.$_$.r5;
  var SVGPreserveAspectRatioAlign_NONE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.v1;
  var SVGPreserveAspectRatio_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.u4;
  var get_nativeCanvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k2;
  var Painter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var Companion_getInstance_14 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var Size__times_impl_fnp4nc = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.h1;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var get_undefined = kotlin_org_jetbrains_kotlinx_kotlinx_browser.$_$.b;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var Companion_instance_2 = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Resource, 'Resource');
  initMetadataForClass(FontResource, 'FontResource', VOID, Resource);
  initMetadataForClass(DrawableResource, 'DrawableResource', VOID, Resource);
  initMetadataForClass(Bitmap, 'Bitmap');
  initMetadataForClass(Vector, 'Vector');
  initMetadataForClass(Svg, 'Svg');
  initMetadataForLambda(vectorResource$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(svgPainter$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(imageResource$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(loadImage$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(LanguageQualifier, 'LanguageQualifier');
  initMetadataForClass(RegionQualifier, 'RegionQualifier');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ThemeQualifier, 'ThemeQualifier', VOID, Enum);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(DensityQualifier, 'DensityQualifier', VOID, Enum);
  initMetadataForClass(ResourceItem, 'ResourceItem');
  initMetadataForLambda(AsyncCache$getOrLoad$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCache$getOrLoad$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(AsyncCache, 'AsyncCache', AsyncCache, VOID, VOID, [2, 0]);
  initMetadataForObject(ResourceCaches, 'ResourceCaches', VOID, VOID, VOID, [0]);
  initMetadataForClass(ResourceEnvironment, 'ResourceEnvironment');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(DefaultComposeEnvironment$1);
  initMetadataForClass(MissingResourceException, 'MissingResourceException', VOID, Exception);
  initMetadataForClass(StringResource, 'StringResource', VOID, Resource);
  initMetadataForLambda(stringResource$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(stringResource$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($loadStringCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($loadStringCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(Value, 'Value');
  initMetadataForClass(Plurals, 'Plurals');
  initMetadataForClass(Array_0, 'Array');
  initMetadataForLambda(getStringItem$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(PluralCategory, 'PluralCategory', VOID, Enum);
  initMetadataForClass(Group, 'Group', VOID, Enum);
  initMetadataForClass(BuildContext, 'BuildContext', BuildContext);
  initMetadataForLambda(_get_childrenSequence_$slambda_9jpw3j, CoroutineImpl, VOID, [1]);
  initMetadataForInterface(Element_0, 'Element');
  initMetadataForClass(MalformedXMLException, 'MalformedXMLException', VOID, Exception);
  initMetadataForObject(TestJsResourceReader, 'TestJsResourceReader', VOID, VOID, VOID, [1, 3]);
  initMetadataForLambda(DefaultJsResourceReader$readAsBlob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($readCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readPartCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readAsBlobCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($asByteArrayCOROUTINE$, CoroutineImpl);
  initMetadataForObject(DefaultJsResourceReader, 'DefaultJsResourceReader', VOID, VOID, VOID, [1, 3]);
  initMetadataForClass(NodeImpl, 'NodeImpl');
  initMetadataForClass(ElementImpl, 'ElementImpl', VOID, NodeImpl, [Element_0]);
  initMetadataForClass(NodeImpl$childNodes$2$1);
  initMetadataForClass(DrawCache, 'DrawCache', DrawCache);
  initMetadataForLambda(Font$slambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(Font$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SvgElement, 'SvgElement');
  initMetadataForClass(SvgPainter, 'SvgPainter', VOID, Painter);
  initMetadataForObject(WebResourcesConfiguration, 'WebResourcesConfiguration');
  initMetadataForLambda(rememberResourceState$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rememberResourceState$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rememberResourceState$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rememberResourceState$slambda_5, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($loadCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($resetCacheCOROUTINE$, CoroutineImpl);
  initMetadataForObject(ResourceWebCache, 'ResourceWebCache', VOID, VOID, VOID, [2, 0]);
  //endregion
  var org_jetbrains_compose_resources_FontResource$stable;
  function FontResource(id, items) {
    Resource.call(this, id, items);
  }
  function get_emptyImageBitmap() {
    _init_properties_ImageResources_kt__6e1y7e();
    var tmp0 = emptyImageBitmap$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('emptyImageBitmap', 0, tmp, _get_emptyImageBitmap_$ref_302yd9(), null);
    return tmp0.u1();
  }
  var emptyImageBitmap$delegate;
  function get_emptyImageVector() {
    _init_properties_ImageResources_kt__6e1y7e();
    var tmp0 = emptyImageVector$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('emptyImageVector', 0, tmp, _get_emptyImageVector_$ref_h5qmfr(), null);
    return tmp0.u1();
  }
  var emptyImageVector$delegate;
  function get_emptySvgPainter() {
    _init_properties_ImageResources_kt__6e1y7e();
    var tmp0 = emptySvgPainter$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('emptySvgPainter', 0, tmp, _get_emptySvgPainter_$ref_tgsxpw(), null);
    return tmp0.u1();
  }
  var emptySvgPainter$delegate;
  function get_imageCache() {
    _init_properties_ImageResources_kt__6e1y7e();
    return imageCache;
  }
  var imageCache;
  var org_jetbrains_compose_resources_DrawableResource$stable;
  var org_jetbrains_compose_resources_ImageCache_Bitmap$stable;
  var org_jetbrains_compose_resources_ImageCache_Vector$stable;
  var org_jetbrains_compose_resources_ImageCache_Svg$stable;
  function DrawableResource(id, items) {
    Resource.call(this, id, items);
  }
  function Bitmap(bitmap) {
    this.cm1_1 = bitmap;
  }
  function Vector(vector) {
    this.dm1_1 = vector;
  }
  function Svg(painter) {
    this.em1_1 = painter;
  }
  function painterResource(resource, $composer, $changed) {
    _init_properties_ImageResources_kt__6e1y7e();
    var $composer_0 = $composer;
    $composer_0.m30(-1508925367);
    if (isTraceInProgress()) {
      traceEventStart(-1508925367, $changed, -1, 'org.jetbrains.compose.resources.painterResource (ImageResources.kt:35)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var environment = $composer_1.u31(this_0).fm1($composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.k31(environment));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = getResourceItemByEnvironment(resource, environment).hm1_1;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var filePath = tmp;
    if (endsWith(filePath, '.xml', true)) {
      $composer_0.m30(-1267601485);
      var tmp0_return = rememberVectorPainter(vectorResource(resource, $composer_0, 14 & $changed), $composer_0, 0);
      $composer_0.n30();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
      $composer_0.n30();
      return tmp0_return;
    } else if (endsWith(filePath, '.svg', true)) {
      $composer_0.m30(-1267490226);
      var tmp1_return = svgPainter(resource, $composer_0, 14 & $changed);
      $composer_0.n30();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
      $composer_0.n30();
      return tmp1_return;
    } else {
      $composer_0.m30(-1267441060);
      var tmp2_return = new BitmapPainter(imageResource(resource, $composer_0, 14 & $changed));
      $composer_0.n30();
      if (isTraceInProgress()) {
        traceEventEnd();
      }
      $composer_0.n30();
      return tmp2_return;
    }
  }
  function vectorResource(resource, $composer, $changed) {
    _init_properties_ImageResources_kt__6e1y7e();
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-1394399862, $changed, -1, 'org.jetbrains.compose.resources.vectorResource (ImageResources.kt:92)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = vectorResource$lambda_0;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp_0 = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.q31(resourceReader)) | $composer_0.k31(density));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = vectorResource$slambda_0(resource, resourceReader, density, null);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp$ret$5 = tmp_1;
    var imageVector$delegate = rememberResourceState(resource, resourceReader, density, tmp_0, tmp$ret$5, $composer_0, 3072 | 14 & $changed);
    var tmp0 = vectorResource$lambda(imageVector$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function svgPainter(resource, $composer, $changed) {
    _init_properties_ImageResources_kt__6e1y7e();
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(1371694195, $changed, -1, 'org.jetbrains.compose.resources.svgPainter (ImageResources.kt:112)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = svgPainter$lambda_0;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp_0 = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.q31(resourceReader)) | $composer_0.k31(density));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = svgPainter$slambda_0(resource, resourceReader, density, null);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp$ret$5 = tmp_1;
    var svgPainter$delegate = rememberResourceState(resource, resourceReader, density, tmp_0, tmp$ret$5, $composer_0, 3072 | 14 & $changed);
    var tmp0 = svgPainter$lambda(svgPainter$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function imageResource(resource, $composer, $changed) {
    _init_properties_ImageResources_kt__6e1y7e();
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(1838739546, $changed, -1, 'org.jetbrains.compose.resources.imageResource (ImageResources.kt:59)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    var resourceEnvironment = rememberResourceEnvironment($composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = imageResource$lambda_0;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp_0 = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.k31(resourceEnvironment)) | $composer_0.q31(resourceReader));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = imageResource$slambda_0(resource, resourceEnvironment, resourceReader, null);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp$ret$4 = tmp_1;
    var imageBitmap$delegate = rememberResourceState(resource, resourceReader, resourceEnvironment, tmp_0, tmp$ret$4, $composer_0, 3072 | 14 & $changed);
    var tmp0 = imageResource$lambda(imageBitmap$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function loadImage(path, cacheKey, resourceReader, decode, $completion) {
    var tmp = get_imageCache();
    return tmp.mm1(cacheKey, loadImage$slambda_0(decode, resourceReader, path, null), $completion);
  }
  function emptyImageBitmap$delegate$lambda() {
    _init_properties_ImageResources_kt__6e1y7e();
    return ImageBitmap(1, 1);
  }
  function _get_emptyImageBitmap_$ref_302yd9() {
    return constructCallableReference(function () {
      return get_emptyImageBitmap();
    }, 0, 0, 383);
  }
  function emptyImageVector$delegate$lambda() {
    _init_properties_ImageResources_kt__6e1y7e();
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp = _Dp___init__impl__ms3zkb(1);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(1);
    return (new Builder('emptyImageVector', tmp, tmp$ret$1, 1.0, 1.0)).g3d();
  }
  function _get_emptyImageVector_$ref_h5qmfr() {
    return constructCallableReference(function () {
      return get_emptyImageVector();
    }, 0, 0, 384);
  }
  function emptySvgPainter$delegate$lambda() {
    _init_properties_ImageResources_kt__6e1y7e();
    return new BitmapPainter(get_emptyImageBitmap());
  }
  function _get_emptySvgPainter_$ref_tgsxpw() {
    return constructCallableReference(function () {
      return get_emptySvgPainter();
    }, 0, 0, 385);
  }
  function vectorResource$lambda($imageVector$delegate) {
    _init_properties_ImageResources_kt__6e1y7e();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('imageVector', KProperty0, false);
    return $imageVector$delegate.u1();
  }
  function vectorResource$lambda_0() {
    _init_properties_ImageResources_kt__6e1y7e();
    return get_emptyImageVector();
  }
  function vectorResource$slambda$lambda($density) {
    return function (it) {
      return new Vector(toImageVector(toXmlElement(it), $density));
    };
  }
  function vectorResource$slambda($resource, $resourceReader, $density, resultContinuation) {
    this.vm1_1 = $resource;
    this.wm1_1 = $resourceReader;
    this.xm1_1 = $density;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(vectorResource$slambda).zm1 = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(vectorResource$slambda).ja = function (p1, $completion) {
    return this.zm1(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(vectorResource$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var path = getResourceItemByEnvironment(this.vm1_1, this.ym1_1).hm1_1;
            this.n9_1 = 1;
            suspendResult = loadImage(path, path, this.wm1_1, vectorResource$slambda$lambda(this.xm1_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cached = suspendResult instanceof Vector ? suspendResult : THROW_CCE();
            return cached.dm1_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(vectorResource$slambda).am2 = function (env, completion) {
    var i = new vectorResource$slambda(this.vm1_1, this.wm1_1, this.xm1_1, completion);
    i.ym1_1 = env;
    return i;
  };
  function vectorResource$slambda_0($resource, $resourceReader, $density, resultContinuation) {
    var i = new vectorResource$slambda($resource, $resourceReader, $density, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.zm1(env, $completion);
    }, 1);
  }
  function svgPainter$lambda($svgPainter$delegate) {
    _init_properties_ImageResources_kt__6e1y7e();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('svgPainter', KProperty0, false);
    return $svgPainter$delegate.u1();
  }
  function svgPainter$lambda_0() {
    _init_properties_ImageResources_kt__6e1y7e();
    return get_emptySvgPainter();
  }
  function svgPainter$slambda$lambda($density) {
    return function (it) {
      return new Svg(toSvgPainter(toSvgElement(it), $density));
    };
  }
  function svgPainter$slambda($resource, $resourceReader, $density, resultContinuation) {
    this.jm2_1 = $resource;
    this.km2_1 = $resourceReader;
    this.lm2_1 = $density;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(svgPainter$slambda).nm2 = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(svgPainter$slambda).ja = function (p1, $completion) {
    return this.nm2(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(svgPainter$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var path = getResourceItemByEnvironment(this.jm2_1, this.mm2_1).hm1_1;
            this.n9_1 = 1;
            suspendResult = loadImage(path, path, this.km2_1, svgPainter$slambda$lambda(this.lm2_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cached = suspendResult instanceof Svg ? suspendResult : THROW_CCE();
            return cached.em1_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(svgPainter$slambda).am2 = function (env, completion) {
    var i = new svgPainter$slambda(this.jm2_1, this.km2_1, this.lm2_1, completion);
    i.mm2_1 = env;
    return i;
  };
  function svgPainter$slambda_0($resource, $resourceReader, $density, resultContinuation) {
    var i = new svgPainter$slambda($resource, $resourceReader, $density, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.nm2(env, $completion);
    }, 1);
  }
  function imageResource$lambda($imageBitmap$delegate) {
    _init_properties_ImageResources_kt__6e1y7e();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('imageBitmap', KProperty0, false);
    return $imageBitmap$delegate.u1();
  }
  function imageResource$lambda_0() {
    _init_properties_ImageResources_kt__6e1y7e();
    return get_emptyImageBitmap();
  }
  function imageResource$slambda$lambda($resourceDensity, $screenDensity) {
    return function (it) {
      return new Bitmap(toImageBitmap(it, $resourceDensity, $screenDensity));
    };
  }
  function imageResource$slambda($resource, $resourceEnvironment, $resourceReader, resultContinuation) {
    this.wm2_1 = $resource;
    this.xm2_1 = $resourceEnvironment;
    this.ym2_1 = $resourceReader;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(imageResource$slambda).am3 = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(imageResource$slambda).ja = function (p1, $completion) {
    return this.am3(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(imageResource$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var item = getResourceItemByEnvironment(this.wm2_1, this.zm2_1);
            var tmp0 = item.gm1_1;
            var tmp$ret$0;
            l$ret$1: do {
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                if (element instanceof DensityQualifier) {
                  tmp$ret$0 = element;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = null;
            }
             while (false);
            var tmp_0 = tmp$ret$0;
            var resourceDensityQualifier = tmp_0 instanceof DensityQualifier ? tmp_0 : null;
            var tmp1_elvis_lhs = resourceDensityQualifier == null ? null : resourceDensityQualifier.dm3_1;
            var resourceDensity = tmp1_elvis_lhs == null ? DensityQualifier_MDPI_getInstance().dm3_1 : tmp1_elvis_lhs;
            var screenDensity = this.xm2_1.hm3_1.dm3_1;
            var path = item.hm1_1;
            this.n9_1 = 1;
            var tmp_1 = path + '-' + screenDensity + 'dpi';
            suspendResult = loadImage(path, tmp_1, this.ym2_1, imageResource$slambda$lambda(resourceDensity, screenDensity), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cached = suspendResult instanceof Bitmap ? suspendResult : THROW_CCE();
            return cached.cm1_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(imageResource$slambda).am2 = function (env, completion) {
    var i = new imageResource$slambda(this.wm2_1, this.xm2_1, this.ym2_1, completion);
    i.zm2_1 = env;
    return i;
  };
  function imageResource$slambda_0($resource, $resourceEnvironment, $resourceReader, resultContinuation) {
    var i = new imageResource$slambda($resource, $resourceEnvironment, $resourceReader, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.am3(env, $completion);
    }, 1);
  }
  function loadImage$slambda($decode, $resourceReader, $path, resultContinuation) {
    this.qm3_1 = $decode;
    this.rm3_1 = $resourceReader;
    this.sm3_1 = $path;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(loadImage$slambda).tm3 = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(loadImage$slambda).ia = function ($completion) {
    return this.tm3($completion);
  };
  protoOf(loadImage$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.rm3_1.um3(this.sm3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.qm3_1(ARGUMENT);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(loadImage$slambda).s2b = function (completion) {
    return new loadImage$slambda(this.qm3_1, this.rm3_1, this.sm3_1, completion);
  };
  function loadImage$slambda_0($decode, $resourceReader, $path, resultContinuation) {
    var i = new loadImage$slambda($decode, $resourceReader, $path, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.tm3($completion);
    }, 0);
  }
  var properties_initialized_ImageResources_kt_9gvoi4;
  function _init_properties_ImageResources_kt__6e1y7e() {
    if (!properties_initialized_ImageResources_kt_9gvoi4) {
      properties_initialized_ImageResources_kt_9gvoi4 = true;
      emptyImageBitmap$delegate = lazy(emptyImageBitmap$delegate$lambda);
      emptyImageVector$delegate = lazy(emptyImageVector$delegate$lambda);
      emptySvgPainter$delegate = lazy(emptySvgPainter$delegate$lambda);
      imageCache = new AsyncCache();
      org_jetbrains_compose_resources_DrawableResource$stable = 0;
      org_jetbrains_compose_resources_ImageCache_Bitmap$stable = 8;
      org_jetbrains_compose_resources_ImageCache_Vector$stable = 0;
      org_jetbrains_compose_resources_ImageCache_Svg$stable = androidx_compose_ui_graphics_painter_Painter$stableprop_getter();
    }
  }
  var org_jetbrains_compose_resources_PluralStringResource$stable;
  var org_jetbrains_compose_resources_LanguageQualifier$stable;
  var org_jetbrains_compose_resources_RegionQualifier$stable;
  function LanguageQualifier(language) {
    this.vm3_1 = language;
  }
  protoOf(LanguageQualifier).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof LanguageQualifier))
      THROW_CCE();
    return this.vm3_1 === other.vm3_1;
  };
  protoOf(LanguageQualifier).hashCode = function () {
    return getStringHashCode(this.vm3_1);
  };
  protoOf(LanguageQualifier).toString = function () {
    return "LanguageQualifier(language='" + this.vm3_1 + "')";
  };
  function RegionQualifier(region) {
    this.wm3_1 = region;
  }
  protoOf(RegionQualifier).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RegionQualifier))
      THROW_CCE();
    return this.wm3_1 === other.wm3_1;
  };
  protoOf(RegionQualifier).hashCode = function () {
    return getStringHashCode(this.wm3_1);
  };
  protoOf(RegionQualifier).toString = function () {
    return "RegionQualifier(region='" + this.wm3_1 + "')";
  };
  var ThemeQualifier_LIGHT_instance;
  var ThemeQualifier_DARK_instance;
  function Companion() {
  }
  protoOf(Companion).xm3 = function (isDark) {
    return isDark ? ThemeQualifier_DARK_getInstance() : ThemeQualifier_LIGHT_getInstance();
  };
  var Companion_instance_3;
  function Companion_getInstance_15() {
    return Companion_instance_3;
  }
  var ThemeQualifier_entriesInitialized;
  function ThemeQualifier_initEntries() {
    if (ThemeQualifier_entriesInitialized)
      return Unit_instance;
    ThemeQualifier_entriesInitialized = true;
    ThemeQualifier_LIGHT_instance = new ThemeQualifier('LIGHT', 0);
    ThemeQualifier_DARK_instance = new ThemeQualifier('DARK', 1);
  }
  function ThemeQualifier(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var DensityQualifier_LDPI_instance;
  var DensityQualifier_MDPI_instance;
  var DensityQualifier_HDPI_instance;
  var DensityQualifier_XHDPI_instance;
  var DensityQualifier_XXHDPI_instance;
  var DensityQualifier_XXXHDPI_instance;
  function Companion_0() {
  }
  protoOf(Companion_0).ym3 = function (dpi) {
    return dpi <= DensityQualifier_LDPI_getInstance().dm3_1 ? DensityQualifier_LDPI_getInstance() : dpi <= DensityQualifier_MDPI_getInstance().dm3_1 ? DensityQualifier_MDPI_getInstance() : dpi <= DensityQualifier_HDPI_getInstance().dm3_1 ? DensityQualifier_HDPI_getInstance() : dpi <= DensityQualifier_XHDPI_getInstance().dm3_1 ? DensityQualifier_XHDPI_getInstance() : dpi <= DensityQualifier_XXHDPI_getInstance().dm3_1 ? DensityQualifier_XXHDPI_getInstance() : DensityQualifier_XXXHDPI_getInstance();
  };
  protoOf(Companion_0).zm3 = function (density) {
    return density <= 0.75 ? DensityQualifier_LDPI_getInstance() : density <= 1.0 ? DensityQualifier_MDPI_getInstance() : density <= 1.5 ? DensityQualifier_HDPI_getInstance() : density <= 2.0 ? DensityQualifier_XHDPI_getInstance() : density <= 3.0 ? DensityQualifier_XXHDPI_getInstance() : DensityQualifier_XXXHDPI_getInstance();
  };
  var Companion_instance_4;
  function Companion_getInstance_16() {
    return Companion_instance_4;
  }
  function values() {
    return [DensityQualifier_LDPI_getInstance(), DensityQualifier_MDPI_getInstance(), DensityQualifier_HDPI_getInstance(), DensityQualifier_XHDPI_getInstance(), DensityQualifier_XXHDPI_getInstance(), DensityQualifier_XXXHDPI_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var DensityQualifier_entriesInitialized;
  function DensityQualifier_initEntries() {
    if (DensityQualifier_entriesInitialized)
      return Unit_instance;
    DensityQualifier_entriesInitialized = true;
    DensityQualifier_LDPI_instance = new DensityQualifier('LDPI', 0, 120);
    DensityQualifier_MDPI_instance = new DensityQualifier('MDPI', 1, 160);
    DensityQualifier_HDPI_instance = new DensityQualifier('HDPI', 2, 240);
    DensityQualifier_XHDPI_instance = new DensityQualifier('XHDPI', 3, 320);
    DensityQualifier_XXHDPI_instance = new DensityQualifier('XXHDPI', 4, 480);
    DensityQualifier_XXXHDPI_instance = new DensityQualifier('XXXHDPI', 5, 640);
  }
  var $ENTRIES;
  function DensityQualifier(name, ordinal, dpi) {
    Enum.call(this, name, ordinal);
    this.dm3_1 = dpi;
  }
  function ThemeQualifier_LIGHT_getInstance() {
    ThemeQualifier_initEntries();
    return ThemeQualifier_LIGHT_instance;
  }
  function ThemeQualifier_DARK_getInstance() {
    ThemeQualifier_initEntries();
    return ThemeQualifier_DARK_instance;
  }
  function DensityQualifier_LDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_LDPI_instance;
  }
  function DensityQualifier_MDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_MDPI_instance;
  }
  function DensityQualifier_HDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_HDPI_instance;
  }
  function DensityQualifier_XHDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_XHDPI_instance;
  }
  function DensityQualifier_XXHDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_XXHDPI_instance;
  }
  function DensityQualifier_XXXHDPI_getInstance() {
    DensityQualifier_initEntries();
    return DensityQualifier_XXXHDPI_instance;
  }
  var org_jetbrains_compose_resources_Resource$stable;
  var org_jetbrains_compose_resources_ResourceItem$stable;
  function ResourceItem(qualifiers, path, offset, size) {
    this.gm1_1 = qualifiers;
    this.hm1_1 = path;
    this.im1_1 = offset;
    this.jm1_1 = size;
  }
  protoOf(ResourceItem).toString = function () {
    return 'ResourceItem(qualifiers=' + toString(this.gm1_1) + ', path=' + this.hm1_1 + ', offset=' + this.im1_1.toString() + ', size=' + this.jm1_1.toString() + ')';
  };
  protoOf(ResourceItem).hashCode = function () {
    var result = hashCode(this.gm1_1);
    result = imul(result, 31) + getStringHashCode(this.hm1_1) | 0;
    result = imul(result, 31) + this.im1_1.hashCode() | 0;
    result = imul(result, 31) + this.jm1_1.hashCode() | 0;
    return result;
  };
  protoOf(ResourceItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResourceItem))
      return false;
    if (!equals(this.gm1_1, other.gm1_1))
      return false;
    if (!(this.hm1_1 === other.hm1_1))
      return false;
    if (!equalsLong(this.im1_1, other.im1_1))
      return false;
    if (!equalsLong(this.jm1_1, other.jm1_1))
      return false;
    return true;
  };
  function Resource(id, items) {
    this.am4_1 = id;
    this.bm4_1 = items;
  }
  protoOf(Resource).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Resource))
      THROW_CCE();
    return this.am4_1 === other.am4_1;
  };
  protoOf(Resource).hashCode = function () {
    return getStringHashCode(this.am4_1);
  };
  var org_jetbrains_compose_resources_AsyncCache$stable;
  var org_jetbrains_compose_resources_ResourceCaches$stable;
  function AsyncCache$getOrLoad$slambda$slambda($load, resultContinuation) {
    this.km4_1 = $load;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCache$getOrLoad$slambda$slambda).mm4 = function ($this$async, $completion) {
    var tmp = this.q24($this$async, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AsyncCache$getOrLoad$slambda$slambda).ja = function (p1, $completion) {
    return this.mm4((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCache$getOrLoad$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.km4_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCache$getOrLoad$slambda$slambda).q24 = function ($this$async, completion) {
    var i = new AsyncCache$getOrLoad$slambda$slambda(this.km4_1, completion);
    i.lm4_1 = $this$async;
    return i;
  };
  function AsyncCache$getOrLoad$slambda$slambda_0($load, resultContinuation) {
    var i = new AsyncCache$getOrLoad$slambda$slambda($load, resultContinuation);
    return constructCallableReference(function ($this$async, $completion) {
      return i.mm4($this$async, $completion);
    }, 1);
  }
  function AsyncCache$getOrLoad$slambda(this$0, $key, $load, resultContinuation) {
    this.vm4_1 = this$0;
    this.wm4_1 = $key;
    this.xm4_1 = $load;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCache$getOrLoad$slambda).mm4 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AsyncCache$getOrLoad$slambda).ja = function (p1, $completion) {
    return this.mm4((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCache$getOrLoad$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.am5_1 = this.vm4_1.km1_1;
            this.zm4_1 = null;
            this.n9_1 = 1;
            suspendResult = this.am5_1.o2u(this.zm4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              var tmp_0;
              try {
                var cached = this.vm4_1.lm1_1.w2(this.wm4_1);
                if (cached == null || cached.n1a()) {
                  var tmp_1 = CoroutineStart_LAZY_getInstance();
                  cached = async(this.ym4_1, VOID, tmp_1, AsyncCache$getOrLoad$slambda$slambda_0(this.xm4_1, null));
                  var tmp0 = this.vm4_1.lm1_1;
                  var tmp2 = this.wm4_1;
                  var value = cached;
                  tmp0.z2(tmp2, value);
                }
                tmp$ret$0 = cached;
                break l$ret$1;
              } catch ($p) {
                var tmp_2;
                var t = $p;
                this.am5_1.q2u(this.zm4_1);
                throw t;
              }
            }
             while (false);
            var tmp_3 = tmp$ret$0;
            this.am5_1.q2u(this.zm4_1);
            var deferred = tmp_3;
            this.n9_1 = 2;
            suspendResult = deferred.r1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCache$getOrLoad$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new AsyncCache$getOrLoad$slambda(this.vm4_1, this.wm4_1, this.xm4_1, completion);
    i.ym4_1 = $this$coroutineScope;
    return i;
  };
  function AsyncCache$getOrLoad$slambda_0(this$0, $key, $load, resultContinuation) {
    var i = new AsyncCache$getOrLoad$slambda(this$0, $key, $load, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.mm4($this$coroutineScope, $completion);
    }, 1);
  }
  function AsyncCache() {
    this.km1_1 = Mutex();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.lm1_1 = LinkedHashMap_init_$Create$();
    ResourceCaches_getInstance().cm5(this);
  }
  protoOf(AsyncCache).mm1 = function (key, load, $completion) {
    return coroutineScope(AsyncCache$getOrLoad$slambda_0(this, key, load, null), $completion);
  };
  function ResourceCaches() {
    ResourceCaches_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.bm5_1 = ArrayList_init_$Create$();
  }
  protoOf(ResourceCaches).cm5 = function (cache) {
    return this.bm5_1.j1(cache);
  };
  var ResourceCaches_instance;
  function ResourceCaches_getInstance() {
    if (ResourceCaches_instance == null)
      new ResourceCaches();
    return ResourceCaches_instance;
  }
  function get_DefaultComposeEnvironment() {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return DefaultComposeEnvironment;
  }
  var DefaultComposeEnvironment;
  function get_LocalComposeEnvironment() {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return LocalComposeEnvironment;
  }
  var LocalComposeEnvironment;
  function get_getResourceEnvironment() {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return getResourceEnvironment;
  }
  var getResourceEnvironment;
  var org_jetbrains_compose_resources_ResourceEnvironment$stable;
  function ResourceEnvironment(language, region, theme, density) {
    this.em3_1 = language;
    this.fm3_1 = region;
    this.gm3_1 = theme;
    this.hm3_1 = density;
  }
  protoOf(ResourceEnvironment).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ResourceEnvironment))
      THROW_CCE();
    if (!this.em3_1.equals(other.em3_1))
      return false;
    if (!this.fm3_1.equals(other.fm3_1))
      return false;
    if (!this.gm3_1.equals(other.gm3_1))
      return false;
    if (!this.hm3_1.equals(other.hm3_1))
      return false;
    return true;
  };
  protoOf(ResourceEnvironment).hashCode = function () {
    var result = this.em3_1.hashCode();
    result = imul(31, result) + this.fm3_1.hashCode() | 0;
    result = imul(31, result) + this.gm3_1.hashCode() | 0;
    result = imul(31, result) + this.hm3_1.hashCode() | 0;
    return result;
  };
  function getResourceItemByEnvironment(_this__u8e3s4, environment) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    // Inline function 'kotlin.also' call
    var this_0 = filterByLocale(toList(_this__u8e3s4.bm4_1), environment.em3_1, environment.fm3_1);
    if (this_0.n1() === 1)
      return first(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = filterBy(this_0, environment.gm3_1);
    if (this_1.n1() === 1)
      return first(this_1);
    // Inline function 'kotlin.also' call
    var this_2 = filterByDensity(this_1, environment.hm3_1);
    if (this_2.n1() === 1)
      return first(this_2);
    // Inline function 'kotlin.let' call
    if (this_2.r()) {
      // Inline function 'kotlin.error' call
      var message = "Resource with ID='" + _this__u8e3s4.am4_1 + "' not found";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      // Inline function 'kotlin.error' call
      var message_0 = "Resource with ID='" + _this__u8e3s4.am4_1 + "' has more than one file: " + joinToString(this_2, VOID, VOID, VOID, VOID, VOID, getResourceItemByEnvironment$lambda);
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
  }
  function rememberResourceEnvironment($composer, $changed) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(707674437, $changed, -1, 'org.jetbrains.compose.resources.rememberResourceEnvironment (ResourceEnvironment.kt:71)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var composeEnvironment = $composer_1.u31(this_0);
    var tmp0 = composeEnvironment.fm1($composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function getSystemResourceEnvironment() {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return get_getResourceEnvironment()();
  }
  function filterByDensity(_this__u8e3s4, density) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    var items = _this__u8e3s4;
    var withQualifier = emptyList();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_entries();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.dm3_1 >= density.dm3_1) {
        destination.j1(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = filterByDensity$lambda;
    var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
    var exactAndHigherQualifiers = sortedWith(destination, tmp$ret$4);
    var _iterator__ex2g4s_0 = exactAndHigherQualifiers.t();
    $l$loop: while (_iterator__ex2g4s_0.u()) {
      var qualifier = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var _iterator__ex2g4s_1 = items.t();
      while (_iterator__ex2g4s_1.u()) {
        var element_0 = _iterator__ex2g4s_1.v();
        var tmp0_0 = element_0.gm1_1;
        var tmp$ret$8;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0_0, Collection)) {
            tmp_0 = tmp0_0.r();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$8 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_2 = tmp0_0.t();
          while (_iterator__ex2g4s_2.u()) {
            var element_1 = _iterator__ex2g4s_2.v();
            if (equals(element_1, qualifier)) {
              tmp$ret$8 = true;
              break $l$block_0;
            }
          }
          tmp$ret$8 = false;
        }
        if (tmp$ret$8) {
          destination_0.j1(element_0);
        }
      }
      withQualifier = destination_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!withQualifier.r())
        break $l$loop;
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withQualifier.r())
      return withQualifier;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_1 = minus(get_entries(), DensityQualifier_LDPI_getInstance());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_3 = tmp0_1.t();
    while (_iterator__ex2g4s_3.u()) {
      var element_2 = _iterator__ex2g4s_3.v();
      if (element_2.dm3_1 < density.dm3_1) {
        destination_1.j1(element_2);
      }
    }
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = filterByDensity$lambda_0;
    var tmp$ret$16 = new sam$kotlin_Comparator$0(tmp_1);
    var lowQualifiers = sortedWith(destination_1, tmp$ret$16);
    var _iterator__ex2g4s_4 = lowQualifiers.t();
    $l$loop_0: while (_iterator__ex2g4s_4.u()) {
      var qualifier_0 = _iterator__ex2g4s_4.v();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$();
      var _iterator__ex2g4s_5 = items.t();
      while (_iterator__ex2g4s_5.u()) {
        var element_3 = _iterator__ex2g4s_5.v();
        var tmp0_2 = element_3.gm1_1;
        var tmp$ret$20;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp_2;
          if (isInterface(tmp0_2, Collection)) {
            tmp_2 = tmp0_2.r();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$20 = false;
            break $l$block_2;
          }
          var _iterator__ex2g4s_6 = tmp0_2.t();
          while (_iterator__ex2g4s_6.u()) {
            var element_4 = _iterator__ex2g4s_6.v();
            if (equals(element_4, qualifier_0)) {
              tmp$ret$20 = true;
              break $l$block_2;
            }
          }
          tmp$ret$20 = false;
        }
        if (tmp$ret$20) {
          destination_2.j1(element_3);
        }
      }
      withQualifier = destination_2;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!withQualifier.r())
        break $l$loop_0;
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withQualifier.r())
      return withQualifier;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_7 = items.t();
    while (_iterator__ex2g4s_7.u()) {
      var element_5 = _iterator__ex2g4s_7.v();
      var tmp0_3 = element_5.gm1_1;
      var tmp$ret$27;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_3;
        if (isInterface(tmp0_3, Collection)) {
          tmp_3 = tmp0_3.r();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$27 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_8 = tmp0_3.t();
        while (_iterator__ex2g4s_8.u()) {
          var element_6 = _iterator__ex2g4s_8.v();
          if (element_6 instanceof DensityQualifier) {
            tmp$ret$27 = false;
            break $l$block_4;
          }
        }
        tmp$ret$27 = true;
      }
      if (tmp$ret$27) {
        destination_3.j1(element_5);
      }
    }
    var withNoDensity = destination_3;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withNoDensity.r())
      return withNoDensity;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_9 = items.t();
    while (_iterator__ex2g4s_9.u()) {
      var element_7 = _iterator__ex2g4s_9.v();
      var tmp0_4 = element_7.gm1_1;
      var tmp$ret$33;
      $l$block_6: {
        // Inline function 'kotlin.collections.any' call
        var tmp_4;
        if (isInterface(tmp0_4, Collection)) {
          tmp_4 = tmp0_4.r();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp$ret$33 = false;
          break $l$block_6;
        }
        var _iterator__ex2g4s_10 = tmp0_4.t();
        while (_iterator__ex2g4s_10.u()) {
          var element_8 = _iterator__ex2g4s_10.v();
          if (equals(element_8, DensityQualifier_LDPI_getInstance())) {
            tmp$ret$33 = true;
            break $l$block_6;
          }
        }
        tmp$ret$33 = false;
      }
      if (tmp$ret$33) {
        destination_4.j1(element_7);
      }
    }
    return destination_4;
  }
  function filterBy(_this__u8e3s4, qualifier) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0 = element.gm1_1;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection)) {
          tmp = tmp0.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          if (equals(element_0, qualifier)) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3) {
        destination.j1(element);
      }
    }
    var withQualifier = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withQualifier.r())
      return withQualifier;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = _this__u8e3s4.t();
    while (_iterator__ex2g4s_1.u()) {
      var element_1 = _iterator__ex2g4s_1.v();
      var tmp0_0 = element_1.gm1_1;
      var tmp$ret$9;
      $l$block_2: {
        // Inline function 'kotlin.collections.none' call
        var tmp_0;
        if (isInterface(tmp0_0, Collection)) {
          tmp_0 = tmp0_0.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s_2 = tmp0_0.t();
        while (_iterator__ex2g4s_2.u()) {
          var element_2 = _iterator__ex2g4s_2.v();
          if (getKClassFromExpression(element_2).equals(getKClassFromExpression(qualifier))) {
            tmp$ret$9 = false;
            break $l$block_2;
          }
        }
        tmp$ret$9 = true;
      }
      if (tmp$ret$9) {
        destination_0.j1(element_1);
      }
    }
    return destination_0;
  }
  function filterByLocale(_this__u8e3s4, language, region) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp0 = element.gm1_1;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(tmp0, Collection)) {
          tmp = tmp0.r();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          if (equals(element_0, language)) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3) {
        destination.j1(element);
      }
    }
    var withLanguage = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = withLanguage.t();
    while (_iterator__ex2g4s_1.u()) {
      var element_1 = _iterator__ex2g4s_1.v();
      var tmp0_0 = element_1.gm1_1;
      var tmp$ret$8;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0_0, Collection)) {
          tmp_0 = tmp0_0.r();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$8 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_2 = tmp0_0.t();
        while (_iterator__ex2g4s_2.u()) {
          var element_2 = _iterator__ex2g4s_2.v();
          if (equals(element_2, region)) {
            tmp$ret$8 = true;
            break $l$block_2;
          }
        }
        tmp$ret$8 = false;
      }
      if (tmp$ret$8) {
        destination_0.j1(element_1);
      }
    }
    var withExactLocale = destination_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withExactLocale.r())
      return withExactLocale;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_3 = withLanguage.t();
    while (_iterator__ex2g4s_3.u()) {
      var element_3 = _iterator__ex2g4s_3.v();
      var tmp0_1 = element_3.gm1_1;
      var tmp$ret$14;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_1;
        if (isInterface(tmp0_1, Collection)) {
          tmp_1 = tmp0_1.r();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$14 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_4 = tmp0_1.t();
        while (_iterator__ex2g4s_4.u()) {
          var element_4 = _iterator__ex2g4s_4.v();
          if (element_4 instanceof RegionQualifier) {
            tmp$ret$14 = false;
            break $l$block_4;
          }
        }
        tmp$ret$14 = true;
      }
      if (tmp$ret$14) {
        destination_1.j1(element_3);
      }
    }
    var withDefaultRegion = destination_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!withDefaultRegion.r())
      return withDefaultRegion;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_5 = _this__u8e3s4.t();
    while (_iterator__ex2g4s_5.u()) {
      var element_5 = _iterator__ex2g4s_5.v();
      var tmp0_2 = element_5.gm1_1;
      var tmp$ret$20;
      $l$block_6: {
        // Inline function 'kotlin.collections.none' call
        var tmp_2;
        if (isInterface(tmp0_2, Collection)) {
          tmp_2 = tmp0_2.r();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$20 = true;
          break $l$block_6;
        }
        var _iterator__ex2g4s_6 = tmp0_2.t();
        while (_iterator__ex2g4s_6.u()) {
          var element_6 = _iterator__ex2g4s_6.v();
          var tmp_3;
          if (element_6 instanceof LanguageQualifier) {
            tmp_3 = true;
          } else {
            tmp_3 = element_6 instanceof RegionQualifier;
          }
          if (tmp_3) {
            tmp$ret$20 = false;
            break $l$block_6;
          }
        }
        tmp$ret$20 = true;
      }
      if (tmp$ret$20) {
        destination_2.j1(element_5);
      }
    }
    return destination_2;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.dm5_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.dm5_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.dm5_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function DefaultComposeEnvironment$1() {
  }
  protoOf(DefaultComposeEnvironment$1).fm1 = function ($composer, $changed) {
    var $composer_0 = $composer;
    $composer_0.m30(1808039825);
    if (isTraceInProgress()) {
      traceEventStart(1808039825, $changed, -1, 'org.jetbrains.compose.resources.DefaultComposeEnvironment.<no name provided>.rememberEnvironment (ResourceEnvironment.kt:43)');
    }
    var composeLocale = Companion_instance.e2y();
    var composeTheme = isSystemInDarkTheme($composer_0, 0);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var composeDensity = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!($composer_0.k31(composeLocale) | $composer_0.l31(composeTheme)) | $composer_0.k31(composeDensity));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      var value = new ResourceEnvironment(new LanguageQualifier(composeLocale.n8m()), new RegionQualifier(composeLocale.o8m()), Companion_instance_3.xm3(composeTheme), Companion_instance_4.zm3(composeDensity.u5e()));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp0 = tmp;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    $composer_0.n30();
    return tmp0;
  };
  function LocalComposeEnvironment$lambda() {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return get_DefaultComposeEnvironment();
  }
  function getResourceItemByEnvironment$lambda(it) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    return it.hm1_1;
  }
  function filterByDensity$lambda(a, b) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = a.dm3_1;
    var tmp$ret$2 = b.dm3_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function filterByDensity$lambda_0(a, b) {
    _init_properties_ResourceEnvironment_kt__2jx9u5();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.dm3_1;
    var tmp$ret$2 = a.dm3_1;
    return compareValues(tmp, tmp$ret$2);
  }
  var properties_initialized_ResourceEnvironment_kt_6hb9vv;
  function _init_properties_ResourceEnvironment_kt__2jx9u5() {
    if (!properties_initialized_ResourceEnvironment_kt_6hb9vv) {
      properties_initialized_ResourceEnvironment_kt_6hb9vv = true;
      DefaultComposeEnvironment = new DefaultComposeEnvironment$1();
      LocalComposeEnvironment = staticCompositionLocalOf(LocalComposeEnvironment$lambda);
      getResourceEnvironment = getSystemEnvironment$ref();
      org_jetbrains_compose_resources_ResourceEnvironment$stable = 0;
    }
  }
  function get_DefaultResourceReader() {
    _init_properties_ResourceReader_kt__hdc5sh();
    return DefaultResourceReader;
  }
  var DefaultResourceReader;
  function get_LocalResourceReader() {
    _init_properties_ResourceReader_kt__hdc5sh();
    return LocalResourceReader;
  }
  var LocalResourceReader;
  var org_jetbrains_compose_resources_MissingResourceException$stable;
  function MissingResourceException(path) {
    Exception_init_$Init$('Missing resource with path: ' + path, this);
    captureStack(this, MissingResourceException);
  }
  function LocalResourceReader$lambda() {
    _init_properties_ResourceReader_kt__hdc5sh();
    return get_DefaultResourceReader();
  }
  var properties_initialized_ResourceReader_kt_tqilcj;
  function _init_properties_ResourceReader_kt__hdc5sh() {
    if (!properties_initialized_ResourceReader_kt_tqilcj) {
      properties_initialized_ResourceReader_kt_tqilcj = true;
      DefaultResourceReader = getPlatformResourceReader();
      LocalResourceReader = staticCompositionLocalOf(LocalResourceReader$lambda);
      org_jetbrains_compose_resources_MissingResourceException$stable = 8;
    }
  }
  var org_jetbrains_compose_resources_StringArrayResource$stable;
  var org_jetbrains_compose_resources_StringResource$stable;
  function StringResource(id, key, items) {
    Resource.call(this, id, items);
    this.gm5_1 = key;
  }
  function getString(resource, $completion) {
    return loadString(resource, get_DefaultResourceReader(), getSystemResourceEnvironment(), $completion);
  }
  function getString_0(resource, formatArgs, $completion) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(formatArgs.length);
    var inductionVariable = 0;
    var last = formatArgs.length;
    while (inductionVariable < last) {
      var item = formatArgs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = toString(item);
      destination.j1(tmp$ret$2);
    }
    return loadString_0(resource, destination, get_DefaultResourceReader(), getSystemResourceEnvironment(), $completion);
  }
  function stringResource(resource, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-1520244580, $changed, -1, 'org.jetbrains.compose.resources.stringResource (StringResources.kt:24)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = stringResource$lambda_0;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp_0 = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.q31(resourceReader));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = stringResource$slambda_0(resource, resourceReader, null);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp$ret$4 = tmp_1;
    var str$delegate = rememberResourceState_0(resource, tmp_0, tmp$ret$4, $composer_0, 48 | 14 & $changed);
    var tmp0 = stringResource$lambda(str$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function stringResource_0(resource, formatArgs, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-217376913, $changed, -1, 'org.jetbrains.compose.resources.stringResource (StringResources.kt:75)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(formatArgs.length);
    var inductionVariable = 0;
    var last = formatArgs.length;
    while (inductionVariable < last) {
      var item = formatArgs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = toString(item);
      destination.j1(tmp$ret$2);
    }
    var args = destination;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = stringResource$lambda_2;
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp_0 = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | $composer_0.q31(args)) | $composer_0.q31(resourceReader));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_1;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = stringResource$slambda_2(resource, args, resourceReader, null);
      $composer_0.j31(value_0);
      tmp_1 = value_0;
    } else {
      tmp_1 = it_0;
    }
    var tmp$ret$7 = tmp_1;
    var str$delegate = rememberResourceState_1(resource, args, tmp_0, tmp$ret$7, $composer_0, 384 | 14 & $changed);
    var tmp0 = stringResource$lambda_1(str$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function loadString(resource, resourceReader, environment, $completion) {
    var tmp = new $loadStringCOROUTINE$(resource, resourceReader, environment, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function loadString_0(resource, args, resourceReader, environment, $completion) {
    var tmp = new $loadStringCOROUTINE$_0(resource, args, resourceReader, environment, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function stringResource$lambda($str$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('str', KProperty0, false);
    return $str$delegate.u1();
  }
  function stringResource$lambda_0() {
    return '';
  }
  function stringResource$slambda($resource, $resourceReader, resultContinuation) {
    this.mm6_1 = $resource;
    this.nm6_1 = $resourceReader;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(stringResource$slambda).pm6 = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(stringResource$slambda).ja = function (p1, $completion) {
    return this.pm6(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(stringResource$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = loadString(this.mm6_1, this.nm6_1, this.om6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(stringResource$slambda).am2 = function (env, completion) {
    var i = new stringResource$slambda(this.mm6_1, this.nm6_1, completion);
    i.om6_1 = env;
    return i;
  };
  function stringResource$slambda_0($resource, $resourceReader, resultContinuation) {
    var i = new stringResource$slambda($resource, $resourceReader, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.pm6(env, $completion);
    }, 1);
  }
  function stringResource$lambda_1($str$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('str', KProperty0, false);
    return $str$delegate.u1();
  }
  function stringResource$lambda_2() {
    return '';
  }
  function stringResource$slambda_1($resource, $args, $resourceReader, resultContinuation) {
    this.ym6_1 = $resource;
    this.zm6_1 = $args;
    this.am7_1 = $resourceReader;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(stringResource$slambda_1).pm6 = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(stringResource$slambda_1).ja = function (p1, $completion) {
    return this.pm6(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(stringResource$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = loadString_0(this.ym6_1, this.zm6_1, this.am7_1, this.bm7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(stringResource$slambda_1).am2 = function (env, completion) {
    var i = new stringResource$slambda_1(this.ym6_1, this.zm6_1, this.am7_1, completion);
    i.bm7_1 = env;
    return i;
  };
  function stringResource$slambda_2($resource, $args, $resourceReader, resultContinuation) {
    var i = new stringResource$slambda_1($resource, $args, $resourceReader, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.pm6(env, $completion);
    }, 1);
  }
  function $loadStringCOROUTINE$(resource, resourceReader, environment, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pm5_1 = resource;
    this.qm5_1 = resourceReader;
    this.rm5_1 = environment;
  }
  protoOf($loadStringCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var resourceItem = getResourceItemByEnvironment(this.pm5_1, this.rm5_1);
            this.n9_1 = 1;
            suspendResult = getStringItem(resourceItem, this.qm5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var item = suspendResult instanceof Value ? suspendResult : THROW_CCE();
            return item.cm7_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $loadStringCOROUTINE$_0(resource, args, resourceReader, environment, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.am6_1 = resource;
    this.bm6_1 = args;
    this.cm6_1 = resourceReader;
    this.dm6_1 = environment;
  }
  protoOf($loadStringCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = loadString(this.am6_1, this.cm6_1, this.dm6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var str = suspendResult;
            return replaceWithArgs(str, this.bm6_1);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function get_SimpleStringFormatRegex() {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    return SimpleStringFormatRegex;
  }
  var SimpleStringFormatRegex;
  function get_stringItemsCache() {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    return stringItemsCache;
  }
  var stringItemsCache;
  var org_jetbrains_compose_resources_StringItem_Value$stable;
  var org_jetbrains_compose_resources_StringItem_Plurals$stable;
  var org_jetbrains_compose_resources_StringItem_Array$stable;
  function Value(text) {
    this.cm7_1 = text;
  }
  protoOf(Value).toString = function () {
    return 'Value(text=' + this.cm7_1 + ')';
  };
  protoOf(Value).hashCode = function () {
    return getStringHashCode(this.cm7_1);
  };
  protoOf(Value).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Value))
      return false;
    if (!(this.cm7_1 === other.cm7_1))
      return false;
    return true;
  };
  function Plurals(items) {
    this.dm7_1 = items;
  }
  protoOf(Plurals).toString = function () {
    return 'Plurals(items=' + toString(this.dm7_1) + ')';
  };
  protoOf(Plurals).hashCode = function () {
    return hashCode(this.dm7_1);
  };
  protoOf(Plurals).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Plurals))
      return false;
    if (!equals(this.dm7_1, other.dm7_1))
      return false;
    return true;
  };
  function Array_0(items) {
    this.em7_1 = items;
  }
  protoOf(Array_0).toString = function () {
    return 'Array(items=' + toString(this.em7_1) + ')';
  };
  protoOf(Array_0).hashCode = function () {
    return hashCode(this.em7_1);
  };
  protoOf(Array_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Array_0))
      return false;
    if (!equals(this.em7_1, other.em7_1))
      return false;
    return true;
  };
  function getStringItem(resourceItem, resourceReader, $completion) {
    var tmp = get_stringItemsCache();
    var tmp_0 = resourceItem.hm1_1 + '/' + resourceItem.im1_1.toString() + '-' + resourceItem.jm1_1.toString();
    return tmp.mm1(tmp_0, getStringItem$slambda_0(resourceReader, resourceItem, null), $completion);
  }
  function replaceWithArgs(_this__u8e3s4, args) {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    var tmp = get_SimpleStringFormatRegex();
    return tmp.ee(_this__u8e3s4, replaceWithArgs$lambda(args));
  }
  function decodeAsPlural(_this__u8e3s4) {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    // Inline function 'kotlin.collections.associate' call
    var this_0 = split(_this__u8e3s4, [',']);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var category = substringBefore(element, _Char___init__impl__6a9atx(58));
      var valueBase64 = substringAfter(element, _Char___init__impl__6a9atx(58));
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(ensureNotNull(Companion_instance_5.m5n(category)), decodeToString(Default_getInstance().gl(valueBase64)));
      destination.z2(pair.xh_1, pair.yh_1);
    }
    return new Plurals(destination);
  }
  function decodeAsArray(_this__u8e3s4) {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(_this__u8e3s4, [',']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = decodeToString(Default_getInstance().gl(item));
      destination.j1(tmp$ret$2);
    }
    return new Array_0(destination);
  }
  function decodeAsString(_this__u8e3s4) {
    _init_properties_StringResourcesUtils_kt__ckiot9();
    return new Value(decodeToString(Default_getInstance().gl(_this__u8e3s4)));
  }
  function getStringItem$slambda($resourceReader, $resourceItem, resultContinuation) {
    this.nm7_1 = $resourceReader;
    this.om7_1 = $resourceItem;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getStringItem$slambda).pm7 = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(getStringItem$slambda).ia = function ($completion) {
    return this.pm7($completion);
  };
  protoOf(getStringItem$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.nm7_1.qm7(this.om7_1.hm1_1, this.om7_1.im1_1, this.om7_1.jm1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var record = decodeToString(ARGUMENT);
            var recordItems = split_0(record, charArrayOf([_Char___init__impl__6a9atx(124)]));
            var recordType = first(recordItems);
            var recordData = last(recordItems);
            switch (recordType) {
              case 'plurals':
                return decodeAsPlural(recordData);
              case 'string-array':
                return decodeAsArray(recordData);
              default:
                return decodeAsString(recordData);
            }

          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(getStringItem$slambda).s2b = function (completion) {
    return new getStringItem$slambda(this.nm7_1, this.om7_1, completion);
  };
  function getStringItem$slambda_0($resourceReader, $resourceItem, resultContinuation) {
    var i = new getStringItem$slambda($resourceReader, $resourceItem, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.pm7($completion);
    }, 0);
  }
  function replaceWithArgs$lambda($args) {
    return function (matchResult) {
      return $args.l1(toInt(matchResult.xe().l1(1)) - 1 | 0);
    };
  }
  var properties_initialized_StringResourcesUtils_kt_tq6hb5;
  function _init_properties_StringResourcesUtils_kt__ckiot9() {
    if (!properties_initialized_StringResourcesUtils_kt_tq6hb5) {
      properties_initialized_StringResourcesUtils_kt_tq6hb5 = true;
      SimpleStringFormatRegex = Regex_init_$Create$('%(\\d+)\\$[ds]');
      stringItemsCache = new AsyncCache();
      org_jetbrains_compose_resources_StringItem_Value$stable = 0;
      org_jetbrains_compose_resources_StringItem_Plurals$stable = 8;
      org_jetbrains_compose_resources_StringItem_Array$stable = 8;
    }
  }
  var PluralCategory_ZERO_instance;
  var PluralCategory_ONE_instance;
  var PluralCategory_TWO_instance;
  var PluralCategory_FEW_instance;
  var PluralCategory_MANY_instance;
  var PluralCategory_OTHER_instance;
  function Companion_1() {
  }
  protoOf(Companion_1).m5n = function (name) {
    var tmp0 = get_entries_0();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (equals_0(element.z_1, name, true)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  };
  var Companion_instance_5;
  function Companion_getInstance_17() {
    return Companion_instance_5;
  }
  function values_0() {
    return [PluralCategory_ZERO_getInstance(), PluralCategory_ONE_getInstance(), PluralCategory_TWO_getInstance(), PluralCategory_FEW_getInstance(), PluralCategory_MANY_getInstance(), PluralCategory_OTHER_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_0());
    return $ENTRIES_0;
  }
  var PluralCategory_entriesInitialized;
  function PluralCategory_initEntries() {
    if (PluralCategory_entriesInitialized)
      return Unit_instance;
    PluralCategory_entriesInitialized = true;
    PluralCategory_ZERO_instance = new PluralCategory('ZERO', 0);
    PluralCategory_ONE_instance = new PluralCategory('ONE', 1);
    PluralCategory_TWO_instance = new PluralCategory('TWO', 2);
    PluralCategory_FEW_instance = new PluralCategory('FEW', 3);
    PluralCategory_MANY_instance = new PluralCategory('MANY', 4);
    PluralCategory_OTHER_instance = new PluralCategory('OTHER', 5);
  }
  var $ENTRIES_0;
  function PluralCategory(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PluralCategory_ZERO_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_ZERO_instance;
  }
  function PluralCategory_ONE_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_ONE_instance;
  }
  function PluralCategory_TWO_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_TWO_instance;
  }
  function PluralCategory_FEW_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_FEW_instance;
  }
  function PluralCategory_MANY_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_MANY_instance;
  }
  function PluralCategory_OTHER_getInstance() {
    PluralCategory_initEntries();
    return PluralCategory_OTHER_instance;
  }
  var org_jetbrains_compose_resources_plural_PluralRuleParseException$stable;
  var org_jetbrains_compose_resources_plural_PluralRule_Condition_And$stable;
  var org_jetbrains_compose_resources_plural_PluralRule_Condition_Or$stable;
  var org_jetbrains_compose_resources_plural_PluralRule_Condition_Relation$stable;
  var org_jetbrains_compose_resources_plural_PluralRule$stable;
  var org_jetbrains_compose_resources_plural_PluralRuleList$stable;
  function parseDp(_this__u8e3s4, density) {
    // Inline function 'kotlin.with' call
    var tmp;
    if (_this__u8e3s4 == null) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0.0);
    } else if (endsWith(_this__u8e3s4, 'dp')) {
      // Inline function 'kotlin.text.toFloat' call
      var this_0 = removeSuffix(_this__u8e3s4, 'dp');
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'androidx.compose.ui.unit.dp' call
      var this_1 = toDouble(this_0);
      tmp = _Dp___init__impl__ms3zkb(this_1);
    } else if (endsWith(_this__u8e3s4, 'px')) {
      // Inline function 'kotlin.text.toFloat' call
      var this_2 = removeSuffix(_this__u8e3s4, 'px');
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = toDouble(this_2);
      tmp = density.e5f(tmp$ret$7);
    } else {
      throw UnsupportedOperationException_init_$Create$('value should ends with dp or px');
    }
    return tmp;
  }
  function parseFillType(fillType) {
    var tmp;
    switch (fillType) {
      case 'nonZero':
        tmp = Companion_getInstance_0().i6j_1;
        break;
      case 'evenOdd':
        tmp = Companion_getInstance_0().j6j_1;
        break;
      default:
        throw UnsupportedOperationException_init_$Create$('unknown fillType: ' + fillType);
    }
    return tmp;
  }
  function parseStrokeCap(strokeCap) {
    var tmp;
    switch (strokeCap) {
      case 'butt':
        tmp = Companion_getInstance_1().s6j_1;
        break;
      case 'round':
        tmp = Companion_getInstance_1().t6j_1;
        break;
      case 'square':
        tmp = Companion_getInstance_1().u6j_1;
        break;
      default:
        throw UnsupportedOperationException_init_$Create$('unknown strokeCap: ' + strokeCap);
    }
    return tmp;
  }
  function parseStrokeJoin(strokeJoin) {
    var tmp;
    switch (strokeJoin) {
      case 'miter':
        tmp = Companion_getInstance_2().w6j_1;
        break;
      case 'round':
        tmp = Companion_getInstance_2().x6j_1;
        break;
      case 'bevel':
        tmp = Companion_getInstance_2().y6j_1;
        break;
      default:
        throw UnsupportedOperationException_init_$Create$('unknown strokeJoin: ' + strokeJoin);
    }
    return tmp;
  }
  function parseColorValue(color) {
    // Inline function 'kotlin.require' call
    if (!startsWith(color, '#')) {
      var message = 'Invalid color value ' + color;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (color.length) {
      case 7:
        // Inline function 'kotlin.UInt.toInt' call

        var this_0 = toUInt(substring(color, 1), 16);
        tmp = _UInt___get_data__impl__f0vqqw(this_0) | -16777216;
        break;
      case 9:
        // Inline function 'kotlin.UInt.toInt' call

        var this_1 = toUInt(substring(color, 1), 16);
        tmp = _UInt___get_data__impl__f0vqqw(this_1);
        break;
      case 4:
        // Inline function 'kotlin.UInt.toInt' call

        var this_2 = toUInt(substring(color, 1), 16);
        var v = _UInt___get_data__impl__f0vqqw(this_2);
        var k = imul(v >> 8 & 15, 1114112);
        k = k | imul(v >> 4 & 15, 4352);
        k = k | imul(v & 15, 17);
        tmp = k | -16777216;
        break;
      case 5:
        // Inline function 'kotlin.UInt.toInt' call

        var this_3 = toUInt(substring(color, 1), 16);
        var v_0 = _UInt___get_data__impl__f0vqqw(this_3);
        var k_0 = imul(v_0 >> 12 & 15, 285212672);
        k_0 = k_0 | imul(v_0 >> 8 & 15, 1114112);
        k_0 = k_0 | imul(v_0 >> 4 & 15, 4352);
        k_0 = k_0 | imul(v_0 & 15, 17);
        tmp = k_0 | -16777216;
        break;
      default:
        tmp = -16777216;
        break;
    }
    return tmp;
  }
  function parseTileMode(tileMode) {
    var tmp;
    switch (tileMode) {
      case 'clamp':
        tmp = Companion_getInstance_3().y6b_1;
        break;
      case 'repeated':
        tmp = Companion_getInstance_3().z6b_1;
        break;
      case 'mirror':
        tmp = Companion_getInstance_3().a6c_1;
        break;
      default:
        throw UnsupportedOperationException_init_$Create$('unknown tileMode: ' + tileMode);
    }
    return tmp;
  }
  function toImageVector(_this__u8e3s4, density) {
    var context = new BuildContext();
    var tmp = parseDp(attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'width'), density);
    var tmp_0 = parseDp(attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'height'), density);
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'viewportWidth');
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = toDouble(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp_2 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'viewportHeight');
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = toDouble(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_3;
    var builder = new Builder(VOID, tmp, tmp_0, tmp_2, tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs, VOID, VOID, attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'autoMirrored') === 'true');
    parseVectorNodes(_this__u8e3s4, builder, context);
    return builder.g3d();
  }
  var Group_Real_instance;
  var Group_Virtual_instance;
  var Group_entriesInitialized;
  function Group_initEntries() {
    if (Group_entriesInitialized)
      return Unit_instance;
    Group_entriesInitialized = true;
    Group_Real_instance = new Group('Real', 0);
    Group_Virtual_instance = new Group('Virtual', 1);
  }
  function Group(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Group_Real_getInstance() {
    Group_initEntries();
    return Group_Real_instance;
  }
  function Group_Virtual_getInstance() {
    Group_initEntries();
    return Group_Virtual_instance;
  }
  function BuildContext() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.rm7_1 = ArrayList_init_$Create$();
  }
  function attributeOrNull(_this__u8e3s4, namespace, name) {
    var value = _this__u8e3s4.sm7(namespace, name);
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(value)) {
      tmp = value;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function parseVectorNodes(_this__u8e3s4, builder, context) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = get_childrenSequence(_this__u8e3s4);
    var tmp = filter(this_0, parseVectorNodes$lambda);
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = (isInterface(tmp, Sequence) ? tmp : THROW_CCE()).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      parseVectorNode(element, builder, context);
    }
  }
  function get_childrenSequence(_this__u8e3s4) {
    return sequence(_get_childrenSequence_$slambda_9jpw3j_0(_this__u8e3s4, null));
  }
  function parseVectorNode(_this__u8e3s4, builder, context) {
    switch (_this__u8e3s4.tm7()) {
      case 'path':
        parsePath(_this__u8e3s4, builder);
        break;
      case 'clip-path':
        parseClipPath(_this__u8e3s4, builder, context);
        break;
      case 'group':
        parseGroup(_this__u8e3s4, builder, context);
        break;
    }
  }
  function parsePath(_this__u8e3s4, builder) {
    var tmp = addPathNodes(attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'pathData'));
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'fillType');
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = parseFillType(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new PathFillType(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_0().i6j_1;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var tmp_3 = tmp_1;
    var tmp2_elvis_lhs = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'name');
    var tmp_4 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var tmp3_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'fillColor');
    var tmp_5;
    if (tmp3_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_5 = parseStringBrush(tmp3_safe_receiver);
    }
    var tmp4_elvis_lhs = tmp_5;
    var tmp_6;
    if (tmp4_elvis_lhs == null) {
      var tmp5_safe_receiver = apptAttr(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'fillColor');
      var tmp_7;
      if (tmp5_safe_receiver == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_7 = parseElementBrush(tmp5_safe_receiver);
      }
      tmp_6 = tmp_7;
    } else {
      tmp_6 = tmp4_elvis_lhs;
    }
    var tmp_8 = tmp_6;
    var tmp6_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'fillAlpha');
    var tmp_9;
    if (tmp6_safe_receiver == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_9 = toDouble(tmp6_safe_receiver);
    }
    var tmp7_elvis_lhs = tmp_9;
    var tmp_10 = tmp7_elvis_lhs == null ? 1.0 : tmp7_elvis_lhs;
    var tmp8_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeColor');
    var tmp_11;
    if (tmp8_safe_receiver == null) {
      tmp_11 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_11 = parseStringBrush(tmp8_safe_receiver);
    }
    var tmp9_elvis_lhs = tmp_11;
    var tmp_12;
    if (tmp9_elvis_lhs == null) {
      var tmp10_safe_receiver = apptAttr(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeColor');
      var tmp_13;
      if (tmp10_safe_receiver == null) {
        tmp_13 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_13 = parseElementBrush(tmp10_safe_receiver);
      }
      tmp_12 = tmp_13;
    } else {
      tmp_12 = tmp9_elvis_lhs;
    }
    var tmp_14 = tmp_12;
    var tmp11_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeAlpha');
    var tmp_15;
    if (tmp11_safe_receiver == null) {
      tmp_15 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_15 = toDouble(tmp11_safe_receiver);
    }
    var tmp12_elvis_lhs = tmp_15;
    var tmp_16 = tmp12_elvis_lhs == null ? 1.0 : tmp12_elvis_lhs;
    var tmp13_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeWidth');
    var tmp_17;
    if (tmp13_safe_receiver == null) {
      tmp_17 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_17 = toDouble(tmp13_safe_receiver);
    }
    var tmp14_elvis_lhs = tmp_17;
    var tmp_18 = tmp14_elvis_lhs == null ? 1.0 : tmp14_elvis_lhs;
    var tmp15_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeLineCap');
    var tmp_19;
    if (tmp15_safe_receiver == null) {
      tmp_19 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_19 = parseStrokeCap(tmp15_safe_receiver);
    }
    var tmp16_elvis_lhs = tmp_19;
    var tmp_20;
    var tmp_21 = tmp16_elvis_lhs;
    if ((tmp_21 == null ? null : new StrokeCap(tmp_21)) == null) {
      tmp_20 = Companion_getInstance_1().s6j_1;
    } else {
      tmp_20 = tmp16_elvis_lhs;
    }
    var tmp_22 = tmp_20;
    var tmp17_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeLineJoin');
    var tmp_23;
    if (tmp17_safe_receiver == null) {
      tmp_23 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_23 = parseStrokeJoin(tmp17_safe_receiver);
    }
    var tmp18_elvis_lhs = tmp_23;
    var tmp_24;
    var tmp_25 = tmp18_elvis_lhs;
    if ((tmp_25 == null ? null : new StrokeJoin(tmp_25)) == null) {
      tmp_24 = Companion_getInstance_2().w6j_1;
    } else {
      tmp_24 = tmp18_elvis_lhs;
    }
    var tmp_26 = tmp_24;
    var tmp19_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'strokeMiterLimit');
    var tmp_27;
    if (tmp19_safe_receiver == null) {
      tmp_27 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_27 = toDouble(tmp19_safe_receiver);
    }
    var tmp20_elvis_lhs = tmp_27;
    var tmp_28 = tmp20_elvis_lhs == null ? 1.0 : tmp20_elvis_lhs;
    var tmp21_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'trimPathStart');
    var tmp_29;
    if (tmp21_safe_receiver == null) {
      tmp_29 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_29 = toDouble(tmp21_safe_receiver);
    }
    var tmp22_elvis_lhs = tmp_29;
    var tmp_30 = tmp22_elvis_lhs == null ? 0.0 : tmp22_elvis_lhs;
    var tmp23_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'trimPathEnd');
    var tmp_31;
    if (tmp23_safe_receiver == null) {
      tmp_31 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_31 = toDouble(tmp23_safe_receiver);
    }
    var tmp24_elvis_lhs = tmp_31;
    var tmp_32 = tmp24_elvis_lhs == null ? 1.0 : tmp24_elvis_lhs;
    var tmp25_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'trimPathOffset');
    var tmp_33;
    if (tmp25_safe_receiver == null) {
      tmp_33 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_33 = toDouble(tmp25_safe_receiver);
    }
    var tmp26_elvis_lhs = tmp_33;
    builder.m9n(tmp, tmp_3, tmp_4, tmp_8, tmp_10, tmp_14, tmp_16, tmp_18, tmp_22, tmp_26, tmp_28, tmp_30, tmp_32, tmp26_elvis_lhs == null ? 0.0 : tmp26_elvis_lhs);
  }
  function parseClipPath(_this__u8e3s4, builder, context) {
    var tmp0_elvis_lhs = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'name');
    builder.k9n(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, addPathNodes(attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'pathData')));
    context.rm7_1.j1(Group_Virtual_getInstance());
  }
  function parseGroup(_this__u8e3s4, builder, context) {
    var tmp0_elvis_lhs = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'name');
    var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp1_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'rotation');
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = toDouble(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
    var tmp3_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'pivotX');
    var tmp_2;
    if (tmp3_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = toDouble(tmp3_safe_receiver);
    }
    var tmp4_elvis_lhs = tmp_2;
    var tmp_3 = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
    var tmp5_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'pivotY');
    var tmp_4;
    if (tmp5_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_4 = toDouble(tmp5_safe_receiver);
    }
    var tmp6_elvis_lhs = tmp_4;
    var tmp_5 = tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs;
    var tmp7_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'scaleX');
    var tmp_6;
    if (tmp7_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_6 = toDouble(tmp7_safe_receiver);
    }
    var tmp8_elvis_lhs = tmp_6;
    var tmp_7 = tmp8_elvis_lhs == null ? 1.0 : tmp8_elvis_lhs;
    var tmp9_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'scaleY');
    var tmp_8;
    if (tmp9_safe_receiver == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_8 = toDouble(tmp9_safe_receiver);
    }
    var tmp10_elvis_lhs = tmp_8;
    var tmp_9 = tmp10_elvis_lhs == null ? 1.0 : tmp10_elvis_lhs;
    var tmp11_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'translateX');
    var tmp_10;
    if (tmp11_safe_receiver == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_10 = toDouble(tmp11_safe_receiver);
    }
    var tmp12_elvis_lhs = tmp_10;
    var tmp_11 = tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs;
    var tmp13_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'translateY');
    var tmp_12;
    if (tmp13_safe_receiver == null) {
      tmp_12 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_12 = toDouble(tmp13_safe_receiver);
    }
    var tmp14_elvis_lhs = tmp_12;
    builder.j9n(tmp, tmp_1, tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, tmp14_elvis_lhs == null ? 0.0 : tmp14_elvis_lhs, get_EmptyPath());
    context.rm7_1.j1(Group_Real_getInstance());
    parseVectorNodes(_this__u8e3s4, builder, context);
    do {
      var removedGroup = removeLastOrNull(context.rm7_1);
      builder.l9n();
    }
     while (equals(removedGroup, Group_Virtual_getInstance()));
  }
  function parseStringBrush(str) {
    return new SolidColor(Color(parseColorValue(str)));
  }
  function apptAttr(_this__u8e3s4, namespace, name) {
    var prefix = _this__u8e3s4.um7(namespace);
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = get_childrenSequence(_this__u8e3s4);
    var tmp = filter(this_0, apptAttr$lambda);
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.vm7() === 'http://schemas.android.com/aapt' && element.wm7() === 'attr' && element.xm7('name') === prefix + ':' + name) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  function parseElementBrush(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = get_childrenSequence(_this__u8e3s4);
    var tmp = filter(this_0, parseElementBrush$lambda);
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.tm7() === 'gradient') {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    return tmp0_safe_receiver == null ? null : parseGradient(tmp0_safe_receiver);
  }
  function parseGradient(_this__u8e3s4) {
    switch (attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'type')) {
      case 'linear':
        return parseLinearGradient(_this__u8e3s4);
      case 'radial':
        return parseRadialGradient(_this__u8e3s4);
      case 'sweep':
        return parseSweepGradient(_this__u8e3s4);
      default:
        return null;
    }
  }
  function parseLinearGradient(_this__u8e3s4) {
    var tmp = Companion_instance_0;
    var tmp_0 = parseColorStops(_this__u8e3s4).slice();
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'startX');
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = toDouble(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'startY');
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = toDouble(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp_3 = _Offset___init__impl__c168vi(tmp$ret$7);
    var tmp4_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'endX');
    var tmp_4;
    if (tmp4_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_4 = toDouble(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_4;
    var tmp0_0 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
    var tmp6_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'endY');
    var tmp_5;
    if (tmp6_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_5 = toDouble(tmp6_safe_receiver);
    }
    var tmp7_elvis_lhs = tmp_5;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2_0 = tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs;
    var v1_0 = fromInt(toRawBits(tmp0_0));
    var v2_0 = fromInt(toRawBits(val2_0));
    var tmp$ret$15 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var tmp_6 = _Offset___init__impl__c168vi(tmp$ret$15);
    var tmp8_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'tileMode');
    var tmp_7;
    if (tmp8_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_7 = parseTileMode(tmp8_safe_receiver);
    }
    var tmp9_elvis_lhs = tmp_7;
    var tmp_8;
    var tmp_9 = tmp9_elvis_lhs;
    if ((tmp_9 == null ? null : new TileMode(tmp_9)) == null) {
      tmp_8 = Companion_getInstance_3().y6b_1;
    } else {
      tmp_8 = tmp9_elvis_lhs;
    }
    return tmp.v6b(tmp_0, tmp_3, tmp_6, tmp_8);
  }
  function parseRadialGradient(_this__u8e3s4) {
    var tmp = Companion_instance_0;
    var tmp_0 = parseColorStops(_this__u8e3s4).slice();
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'centerX');
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = toDouble(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'centerY');
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = toDouble(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp_3 = _Offset___init__impl__c168vi(tmp$ret$7);
    var tmp4_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'gradientRadius');
    var tmp_4;
    if (tmp4_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_4 = toDouble(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_4;
    var tmp_5 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
    var tmp6_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'tileMode');
    var tmp_6;
    if (tmp6_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_6 = parseTileMode(tmp6_safe_receiver);
    }
    var tmp7_elvis_lhs = tmp_6;
    var tmp_7;
    var tmp_8 = tmp7_elvis_lhs;
    if ((tmp_8 == null ? null : new TileMode(tmp_8)) == null) {
      tmp_7 = Companion_getInstance_3().y6b_1;
    } else {
      tmp_7 = tmp7_elvis_lhs;
    }
    return tmp.e6c(tmp_0, tmp_3, tmp_5, tmp_7);
  }
  function parseSweepGradient(_this__u8e3s4) {
    var tmp = Companion_instance_0;
    var tmp_0 = parseColorStops(_this__u8e3s4).slice();
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'centerX');
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = toDouble(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'centerY');
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_2 = toDouble(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$7 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$6 = _Offset___init__impl__c168vi(tmp$ret$7);
    return tmp.f6c(tmp_0, tmp$ret$6);
  }
  function parseColorStops(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = get_childrenSequence(_this__u8e3s4);
    var tmp = filter(this_0, parseColorStops$lambda);
    var tmp_0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    var items = toList_0(filter(tmp_0, parseColorStops$lambda_0));
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = items.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp0_safe_receiver = parseColorStop(item, index_0 / coerceAtLeast(get_lastIndex(items), 1));
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp0_safe_receiver);
      }
    }
    var colorStops = destination;
    if (colorStops.r()) {
      var tmp0_safe_receiver_0 = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'startColor');
      var tmp_1;
      if (tmp0_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_1 = parseColorValue(tmp0_safe_receiver_0);
      }
      var startColor = tmp_1;
      var tmp1_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'centerColor');
      var tmp_2;
      if (tmp1_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = parseColorValue(tmp1_safe_receiver);
      }
      var centerColor = tmp_2;
      var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'endColor');
      var tmp_3;
      if (tmp2_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_3 = parseColorValue(tmp2_safe_receiver);
      }
      var endColor = tmp_3;
      if (!(startColor == null)) {
        colorStops.j1(to(0.0, new Color_0(Color(startColor))));
      }
      if (!(centerColor == null)) {
        colorStops.j1(to(0.5, new Color_0(Color(centerColor))));
      }
      if (!(endColor == null)) {
        colorStops.j1(to(1.0, new Color_0(Color(endColor))));
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(colorStops);
  }
  function parseColorStop(_this__u8e3s4, defaultOffset) {
    var tmp0_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'offset');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = toDouble(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var offset = tmp1_elvis_lhs == null ? defaultOffset : tmp1_elvis_lhs;
    var tmp2_safe_receiver = attributeOrNull(_this__u8e3s4, 'http://schemas.android.com/apk/res/android', 'color');
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = parseColorValue(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var color = tmp_1;
    return to(offset, new Color_0(Color(color)));
  }
  function parseVectorNodes$lambda(it) {
    return !(it == null) ? isInterface(it, Element_0) : false;
  }
  function _get_childrenSequence_$slambda_9jpw3j($this_childrenSequence, resultContinuation) {
    this.gm8_1 = $this_childrenSequence;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(_get_childrenSequence_$slambda_9jpw3j).jm8 = function ($this$sequence, $completion) {
    var tmp = this.km8($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(_get_childrenSequence_$slambda_9jpw3j).ja = function (p1, $completion) {
    return this.jm8(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(_get_childrenSequence_$slambda_9jpw3j).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.im8_1 = until(0, this.gm8_1.lm8().a()).t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.im8_1.u()) {
              this.n9_1 = 3;
              continue $sm;
            }

            var i = this.im8_1.v();
            this.n9_1 = 2;
            suspendResult = this.hm8_1.oi(this.gm8_1.lm8().mm8(i), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(_get_childrenSequence_$slambda_9jpw3j).km8 = function ($this$sequence, completion) {
    var i = new _get_childrenSequence_$slambda_9jpw3j(this.gm8_1, completion);
    i.hm8_1 = $this$sequence;
    return i;
  };
  function _get_childrenSequence_$slambda_9jpw3j_0($this_childrenSequence, resultContinuation) {
    var i = new _get_childrenSequence_$slambda_9jpw3j($this_childrenSequence, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.jm8($this$sequence, $completion);
    }, 1);
  }
  function apptAttr$lambda(it) {
    return !(it == null) ? isInterface(it, Element_0) : false;
  }
  function parseElementBrush$lambda(it) {
    return !(it == null) ? isInterface(it, Element_0) : false;
  }
  function parseColorStops$lambda(it) {
    return !(it == null) ? isInterface(it, Element_0) : false;
  }
  function parseColorStops$lambda_0(it) {
    return it.tm7() === 'item';
  }
  function Element_0() {
  }
  var org_jetbrains_compose_resources_vector_xmldom_MalformedXMLException$stable;
  function MalformedXMLException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, MalformedXMLException);
  }
  function toXmlElement(_this__u8e3s4) {
    var xmlString = decodeToString(_this__u8e3s4);
    var xmlDom = (new DOMParser()).parseFromString(xmlString, 'application/xml');
    var tmp0_elvis_lhs = xmlDom.documentElement;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new MalformedXMLException('missing documentElement');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var domElement = tmp;
    return new ElementImpl(domElement);
  }
  var org_jetbrains_compose_resources_Intl_Locale$stable;
  function getSystemEnvironment() {
    var locale = new Intl.Locale(window.navigator.language);
    var isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
    var dpi = numberToInt(window.devicePixelRatio * 96);
    var tmp = new LanguageQualifier(locale.language);
    var tmp0_elvis_lhs = locale.region;
    return new ResourceEnvironment(tmp, new RegionQualifier(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs), Companion_instance_3.xm3(isDarkTheme), Companion_instance_4.ym3(dpi));
  }
  function getSystemEnvironment$ref() {
    return constructCallableReference(function () {
      return getSystemEnvironment();
    }, 0, 0, 386, 'getSystemEnvironment');
  }
  var org_jetbrains_compose_resources_DefaultJsResourceReader$stable;
  function getPlatformResourceReader() {
    if (isInTestEnvironment())
      return TestJsResourceReader_instance;
    return DefaultJsResourceReader_instance;
  }
  function isInTestEnvironment() {
    return window.composeResourcesTesting == true;
  }
  function readByteArray($this, path) {
    var resPath = WebResourcesConfiguration_getInstance().nm8_1(path);
    var request = new XMLHttpRequest();
    request.open('GET', resPath, false);
    request.overrideMimeType('text/plain; charset=x-user-defined');
    request.send();
    if (request.status === 200) {
      var text = request.responseText;
      var bytes = new Uint8Array(text.length);
      for (var i = 0; i < text.length; i++) {
        bytes[i] = text.charCodeAt(i) & 255;
      }
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return bytes;
    }
    throw new MissingResourceException(resPath);
  }
  function TestJsResourceReader() {
  }
  protoOf(TestJsResourceReader).um3 = function (path, $completion) {
    return readByteArray(this, path);
  };
  protoOf(TestJsResourceReader).qm7 = function (path, offset, size, $completion) {
    return sliceArray(readByteArray(this, path), until(convertToInt(offset), convertToInt(add(offset, size))));
  };
  var TestJsResourceReader_instance;
  function TestJsResourceReader_getInstance() {
    return TestJsResourceReader_instance;
  }
  function readAsBlob($this, path, $completion) {
    var tmp = new $readAsBlobCOROUTINE$($this, path, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function asByteArray($this, $receiver, $completion) {
    var tmp = new $asByteArrayCOROUTINE$($this, $receiver, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function DefaultJsResourceReader$readAsBlob$slambda($resPath, resultContinuation) {
    this.rm9_1 = $resPath;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultJsResourceReader$readAsBlob$slambda).tm9 = function (it, $completion) {
    var tmp = this.um9(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultJsResourceReader$readAsBlob$slambda).ja = function (p1, $completion) {
    return this.tm9((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultJsResourceReader$readAsBlob$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var this_0 = window.fetch(this.rm9_1);
            suspendResult = await_0(this_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultJsResourceReader$readAsBlob$slambda).um9 = function (it, completion) {
    var i = new DefaultJsResourceReader$readAsBlob$slambda(this.rm9_1, completion);
    i.sm9_1 = it;
    return i;
  };
  function DefaultJsResourceReader$readAsBlob$slambda_0($resPath, resultContinuation) {
    var i = new DefaultJsResourceReader$readAsBlob$slambda($resPath, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.tm9(it, $completion);
    }, 1);
  }
  function $readCOROUTINE$(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dma_1 = _this__u8e3s4;
    this.ema_1 = path;
  }
  protoOf($readCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = readAsBlob(this.dma_1, this.ema_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = asByteArray(this.dma_1, ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readPartCOROUTINE$(_this__u8e3s4, path, offset, size, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nma_1 = _this__u8e3s4;
    this.oma_1 = path;
    this.pma_1 = offset;
    this.qma_1 = size;
  }
  protoOf($readPartCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = readAsBlob(this.nma_1, this.oma_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var part = suspendResult.slice(convertToInt(this.pma_1), convertToInt(add(this.pma_1, this.qma_1)));
            this.n9_1 = 2;
            suspendResult = asByteArray(this.nma_1, part, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readAsBlobCOROUTINE$(_this__u8e3s4, path, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wm8_1 = _this__u8e3s4;
    this.xm8_1 = path;
  }
  protoOf($readAsBlobCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.ym8_1 = WebResourcesConfiguration_getInstance().nm8_1(this.xm8_1);
            this.n9_1 = 1;
            var tmp_0 = ResourceWebCache_getInstance();
            suspendResult = tmp_0.wma(this.ym8_1, DefaultJsResourceReader$readAsBlob$slambda_0(this.ym8_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            if (!response.ok) {
              throw new MissingResourceException(this.ym8_1);
            }

            this.n9_1 = 2;
            suspendResult = await_0(response.blob(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $asByteArrayCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hm9_1 = _this__u8e3s4;
    this.im9_1 = _this__u8e3s4_0;
  }
  protoOf($asByteArrayCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = this.im9_1.arrayBuffer();
            var buffer = tmp_0 instanceof Promise ? tmp_0 : THROW_CCE();
            this.n9_1 = 1;
            suspendResult = await_0(buffer, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new Int8Array(ARGUMENT);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DefaultJsResourceReader() {
  }
  protoOf(DefaultJsResourceReader).um3 = function (path, $completion) {
    var tmp = new $readCOROUTINE$(this, path, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultJsResourceReader).qm7 = function (path, offset, size, $completion) {
    var tmp = new $readPartCOROUTINE$(this, path, offset, size, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var DefaultJsResourceReader_instance;
  function DefaultJsResourceReader_getInstance() {
    return DefaultJsResourceReader_instance;
  }
  var org_jetbrains_compose_resources_vector_xmldom_ElementImpl$stable;
  function ElementImpl(element) {
    NodeImpl.call(this, element);
    this.bmb_1 = element;
  }
  protoOf(ElementImpl).wm7 = function () {
    return this.bmb_1.localName;
  };
  protoOf(ElementImpl).vm7 = function () {
    var tmp0_elvis_lhs = this.bmb_1.namespaceURI;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(ElementImpl).sm7 = function (nameSpaceURI, localName) {
    var tmp0_elvis_lhs = this.bmb_1.getAttributeNS(nameSpaceURI, localName);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(ElementImpl).xm7 = function (name) {
    var tmp0_elvis_lhs = this.bmb_1.getAttribute(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  var org_jetbrains_compose_resources_vector_xmldom_NodeImpl$stable;
  function NodeImpl$childNodes$2$1(this$0) {
    this.hmb_1 = this$0;
    this.gmb_1 = this$0.cmb_1.childNodes.length;
  }
  protoOf(NodeImpl$childNodes$2$1).mm8 = function (i) {
    var tmp0_elvis_lhs = this.hmb_1.cmb_1.childNodes.item(i);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IndexOutOfBoundsException_init_$Create$('no child node accessible at index=' + i);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var child = tmp;
    var tmp_0;
    if (child instanceof Element) {
      tmp_0 = new ElementImpl(child);
    } else {
      tmp_0 = new NodeImpl(child);
    }
    return tmp_0;
  };
  protoOf(NodeImpl$childNodes$2$1).a = function () {
    return this.gmb_1;
  };
  function NodeImpl$childNodes$delegate$lambda(this$0) {
    return function () {
      return new NodeImpl$childNodes$2$1(this$0);
    };
  }
  function NodeImpl$_get_childNodes_$ref_tsfx09() {
    return constructCallableReference(function (p0) {
      return p0.lm8();
    }, 1, 0, 387);
  }
  function NodeImpl(n) {
    this.cmb_1 = n;
    this.dmb_1 = '';
    this.emb_1 = '';
    var tmp = this;
    tmp.fmb_1 = lazy(NodeImpl$childNodes$delegate$lambda(this));
  }
  protoOf(NodeImpl).tm7 = function () {
    return this.cmb_1.nodeName;
  };
  protoOf(NodeImpl).wm7 = function () {
    return this.dmb_1;
  };
  protoOf(NodeImpl).vm7 = function () {
    return this.emb_1;
  };
  protoOf(NodeImpl).lm8 = function () {
    var tmp0 = this.fmb_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('childNodes', 1, tmp, NodeImpl$_get_childNodes_$ref_tsfx09(), null);
    return tmp0.u1();
  };
  protoOf(NodeImpl).um7 = function (namespaceURI) {
    var tmp0_elvis_lhs = this.cmb_1.lookupPrefix(namespaceURI);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  var org_jetbrains_compose_resources_DrawCache$stable;
  function clear($this, $receiver) {
    $receiver.b6q(Companion_getInstance_4().i6b_1, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_5().y69_1);
  }
  function DrawCache() {
    this.imb_1 = null;
    this.jmb_1 = null;
    this.kmb_1 = null;
    this.lmb_1 = LayoutDirection_Ltr_getInstance();
    this.mmb_1 = Companion_getInstance_6().n5g_1;
    this.nmb_1 = Companion_getInstance_7().x6g_1;
    this.omb_1 = new CanvasDrawScope();
  }
  protoOf(DrawCache).m9m = function (config, size, density, layoutDirection, block) {
    this.kmb_1 = density;
    this.lmb_1 = layoutDirection;
    var targetImage = this.imb_1;
    var targetCanvas = this.jmb_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (targetImage == null || targetCanvas == null) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_1 = convertToInt(shiftRight(value, 32)) > targetImage.h5e();
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) > targetImage.i5e();
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(this.nmb_1 === config);
    }
    if (tmp) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp_2 = convertToInt(shiftRight(value_1, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp$ret$6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      targetImage = ImageBitmap(tmp_2, tmp$ret$6, config);
      targetCanvas = Canvas(targetImage);
      this.imb_1 = targetImage;
      this.jmb_1 = targetCanvas;
      this.nmb_1 = config;
    }
    this.mmb_1 = size;
    var tmp0 = this.omb_1;
    var tmp6 = targetCanvas;
    // Inline function 'androidx.compose.ui.graphics.drawscope.CanvasDrawScope.draw' call
    var size_0 = toSize(size);
    var _destruct__k2r9zo = tmp0.h6o_1;
    var prevDensity = _destruct__k2r9zo.zh();
    var prevLayoutDirection = _destruct__k2r9zo.ai();
    var prevCanvas = _destruct__k2r9zo.hr();
    var prevSize = _destruct__k2r9zo.j6p();
    // Inline function 'kotlin.apply' call
    var this_0 = tmp0.h6o_1;
    this_0.f6p_1 = density;
    this_0.g6p_1 = layoutDirection;
    this_0.h6p_1 = tmp6;
    this_0.i6p_1 = size_0;
    tmp6.t6d();
    clear(this, tmp0);
    block(tmp0);
    tmp6.u6d();
    // Inline function 'kotlin.apply' call
    var this_1 = tmp0.h6o_1;
    this_1.f6p_1 = prevDensity;
    this_1.g6p_1 = prevLayoutDirection;
    this_1.h6p_1 = prevCanvas;
    this_1.i6p_1 = prevSize;
    targetImage.w6g();
  };
  protoOf(DrawCache).n9m = function (target, alpha, colorFilter) {
    var targetImage = this.imb_1;
    // Inline function 'kotlin.check' call
    if (!!(targetImage == null)) {
      var message = 'drawCachedImage must be invoked first before attempting to draw the result into another destination';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    target.d6q(targetImage, VOID, this.mmb_1, VOID, VOID, alpha, VOID, colorFilter);
  };
  function get_defaultFont() {
    _init_properties_FontResources_skiko_kt__g77iad();
    return defaultFont;
  }
  var defaultFont;
  function get_fontCache() {
    _init_properties_FontResources_skiko_kt__g77iad();
    return fontCache;
  }
  var fontCache;
  function Font_0(resource, weight, style, variationSettings, $composer, $changed, $default) {
    _init_properties_FontResources_skiko_kt__g77iad();
    var weight_0 = {_v: weight};
    var style_0 = {_v: new FontStyle(style)};
    var variationSettings_0 = {_v: variationSettings};
    var $composer_0 = $composer;
    if (!(($default & 2) === 0)) {
      weight_0._v = Companion_getInstance_8().b7z_1;
    }
    if (!(($default & 4) === 0)) {
      style_0._v = new FontStyle(Companion_getInstance_9().k7z_1);
    }
    if (!(($default & 8) === 0)) {
      variationSettings_0._v = FontVariation_instance.x88(weight_0._v, style_0._v.d7x_1, []);
    }
    if (isTraceInProgress()) {
      traceEventStart(-1140522915, $changed, -1, 'org.jetbrains.compose.resources.Font (FontResources.skiko.kt:56)');
    }
    var resourceReader = get_currentOrPreview(get_LocalResourceReader(), $composer_0, 6);
    var tmp = weight_0._v;
    var tmp_0 = style_0._v;
    var tmp_1 = variationSettings_0._v;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp_2;
    if (false || it === Companion_getInstance().f30_1) {
      var value = Font$lambda_0;
      $composer_0.j31(value);
      tmp_2 = value;
    } else {
      tmp_2 = it;
    }
    var tmp_3 = tmp_2;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(resource) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(weight_0._v) || ($changed & 48) === 32)) | (($changed & 896 ^ 384) > 256 && $composer_0.m31(_FontStyle___get_value__impl__gx8aaz(style_0._v.d7x_1)) || ($changed & 384) === 256)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.k31(variationSettings_0._v) || ($changed & 3072) === 2048)) | $composer_0.q31(resourceReader));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_4;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var value_0 = Font$slambda_0(resource, weight_0, style_0, variationSettings_0, resourceReader, null);
      $composer_0.j31(value_0);
      tmp_4 = value_0;
    } else {
      tmp_4 = it_0;
    }
    var tmp$ret$4 = tmp_4;
    var fontFile$delegate = rememberResourceState_2(resource, tmp, tmp_0, tmp_1, tmp_3, tmp$ret$4, $composer_0, 24576 | 14 & $changed | 112 & $changed | 896 & $changed | 7168 & $changed);
    var tmp0 = Font$lambda(fontFile$delegate);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function getCacheKey(_this__u8e3s4) {
    _init_properties_FontResources_skiko_kt__g77iad();
    var defaultDensity = Density(1.0);
    // Inline function 'kotlin.collections.map' call
    var this_0 = _this__u8e3s4.m88_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = '' + getKClassFromExpression(item).o() + '(' + item.k88() + ',' + item.r88(defaultDensity) + ')';
      destination.j1(tmp$ret$2);
    }
    return joinToString(sorted(destination), ',');
  }
  function footprint(_this__u8e3s4) {
    _init_properties_FontResources_skiko_kt__g77iad();
    var tmp = _this__u8e3s4.length;
    var tmp0_safe_receiver = lastOrNull(_this__u8e3s4);
    return '[' + tmp + ':' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver) + ']';
  }
  function Font$lambda($fontFile$delegate) {
    _init_properties_FontResources_skiko_kt__g77iad();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('fontFile', KProperty0, false);
    return $fontFile$delegate.u1();
  }
  function Font$lambda_0() {
    _init_properties_FontResources_skiko_kt__g77iad();
    return get_defaultFont();
  }
  function Font$slambda$slambda($resourceReader, $path, $key, $weight, $style, $variationSettings, resultContinuation) {
    this.xmb_1 = $resourceReader;
    this.ymb_1 = $path;
    this.zmb_1 = $key;
    this.amc_1 = $weight;
    this.bmc_1 = $style;
    this.cmc_1 = $variationSettings;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Font$slambda$slambda).dmc = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Font$slambda$slambda).ia = function ($completion) {
    return this.dmc($completion);
  };
  protoOf(Font$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.xmb_1.um3(this.ymb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var fontBytes = suspendResult;
            return Font(this.zmb_1 + footprint(fontBytes), fontBytes, this.amc_1._v, this.bmc_1._v.d7x_1, this.cmc_1._v);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Font$slambda$slambda).s2b = function (completion) {
    return new Font$slambda$slambda(this.xmb_1, this.ymb_1, this.zmb_1, this.amc_1, this.bmc_1, this.cmc_1, completion);
  };
  function Font$slambda$slambda_0($resourceReader, $path, $key, $weight, $style, $variationSettings, resultContinuation) {
    var i = new Font$slambda$slambda($resourceReader, $path, $key, $weight, $style, $variationSettings, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.dmc($completion);
    }, 0);
  }
  function Font$slambda($resource, $weight, $style, $variationSettings, $resourceReader, resultContinuation) {
    this.mmc_1 = $resource;
    this.nmc_1 = $weight;
    this.omc_1 = $style;
    this.pmc_1 = $variationSettings;
    this.qmc_1 = $resourceReader;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Font$slambda).smc = function (env, $completion) {
    var tmp = this.am2(env, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Font$slambda).ja = function (p1, $completion) {
    return this.smc(p1 instanceof ResourceEnvironment ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Font$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var path = getResourceItemByEnvironment(this.mmc_1, this.rmc_1).hm1_1;
            var key = path + ':' + this.nmc_1._v.toString() + ':' + FontStyle__toString_impl_thncxr(this.omc_1._v.d7x_1) + ':' + getCacheKey(this.pmc_1._v);
            this.n9_1 = 1;
            var tmp_0 = get_fontCache();
            suspendResult = tmp_0.mm1(key, Font$slambda$slambda_0(this.qmc_1, path, key, this.nmc_1, this.omc_1, this.pmc_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Font$slambda).am2 = function (env, completion) {
    var i = new Font$slambda(this.mmc_1, this.nmc_1, this.omc_1, this.pmc_1, this.qmc_1, completion);
    i.rmc_1 = env;
    return i;
  };
  function Font$slambda_0($resource, $weight, $style, $variationSettings, $resourceReader, resultContinuation) {
    var i = new Font$slambda($resource, $weight, $style, $variationSettings, $resourceReader, resultContinuation);
    return constructCallableReference(function (env, $completion) {
      return i.smc(env, $completion);
    }, 1);
  }
  var properties_initialized_FontResources_skiko_kt_wwtlnx;
  function _init_properties_FontResources_skiko_kt__g77iad() {
    if (!properties_initialized_FontResources_skiko_kt_wwtlnx) {
      properties_initialized_FontResources_skiko_kt_wwtlnx = true;
      defaultFont = SystemFont_init_$Create$('org.jetbrains.compose.resources.defaultFont');
      fontCache = new AsyncCache();
    }
  }
  var org_jetbrains_compose_resources_SvgElement$stable;
  function toSvgPainter(_this__u8e3s4, density) {
    return new SvgPainter(_this__u8e3s4.tmc_1, density);
  }
  function SvgElement(svgdom) {
    this.tmc_1 = svgdom;
  }
  function toSvgElement(_this__u8e3s4) {
    return new SvgElement(SVGDOM_init_$Create$(Companion_getInstance_10().r5m(_this__u8e3s4)));
  }
  function toImageBitmap(_this__u8e3s4, resourceDensity, targetDensity) {
    var image = Companion_getInstance_11().e5q(_this__u8e3s4);
    var targetImage;
    if (resourceDensity > targetDensity) {
      var scale = targetDensity / resourceDensity;
      var targetH = image.i5e() * scale;
      var targetW = image.h5e() * scale;
      var srcRect = Companion_instance_1.c5u(image.h5e(), image.i5e());
      var dstRect = Companion_instance_1.c5u(targetW, targetH);
      // Inline function 'kotlin.run' call
      var $this$run = Companion_getInstance_12().s5u(numberToInt(targetW), numberToInt(targetH));
      // Inline function 'kotlin.apply' call
      var this_0 = Paint_init_$Create$();
      this_0.w5q(true);
      var paint = this_0;
      $this$run.x5u().v5k(image, srcRect, dstRect, Companion_getInstance_13().p5k_1, paint, true);
      targetImage = $this$run.y5u();
    } else {
      targetImage = image;
    }
    return toComposeImageBitmap(targetImage);
  }
  function get_currentOrPreview(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-193451530, $changed, -1, 'org.jetbrains.compose.resources.<get-currentOrPreview> (ResourceReader.skiko.kt:6)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var $composer_1 = $composer_0;
    var tmp0 = $composer_1.u31(_this__u8e3s4);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  var org_jetbrains_compose_resources_SvgPainter$stable;
  function drawSvg($this, $receiver, size) {
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = $receiver.v6p().x5u();
    var tmp0_safe_receiver = $this.cmd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$2 = floatFromBits(bits);
      tmp0_safe_receiver.d66(new SVGLength(tmp$ret$2, SVGLengthUnit_PX_getInstance()));
    }
    var tmp1_safe_receiver = $this.cmd_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$6 = floatFromBits(bits_0);
      tmp1_safe_receiver.e66(new SVGLength(tmp$ret$6, SVGLengthUnit_PX_getInstance()));
    }
    var tmp2_safe_receiver = $this.cmd_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.f66(SVGPreserveAspectRatio_init_$Create$(SVGPreserveAspectRatioAlign_NONE_getInstance()));
    }
    $this.amd_1.o65(get_nativeCanvas(canvas));
  }
  function SvgPainter$onDraw$lambda(this$0) {
    return function ($this$drawCachedImage) {
      drawSvg(this$0, $this$drawCachedImage, $this$drawCachedImage.o5d());
      return Unit_instance;
    };
  }
  function SvgPainter(dom, density) {
    Painter.call(this);
    this.amd_1 = dom;
    this.bmd_1 = density;
    this.cmd_1 = this.amd_1.n65();
    var tmp = this;
    // Inline function 'kotlin.run' call
    var tmp0_safe_receiver = this.cmd_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h5e();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s65(SVGLengthUnit_PX_getInstance());
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q65_1;
    var width = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    var tmp4_safe_receiver = this.cmd_1;
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.i5e();
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.s65(SVGLengthUnit_PX_getInstance());
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.q65_1;
    var height = tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs;
    var tmp_0;
    if (width === 0.0 && height === 0.0) {
      tmp_0 = Companion_getInstance_14().k5e_1;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(width));
      var v2 = fromInt(toRawBits(height));
      var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp_0 = _Size___init__impl__aywn0g(tmp$ret$3);
    }
    tmp.dmd_1 = tmp_0;
    var tmp_1;
    var tmp1_safe_receiver_0 = this.cmd_1;
    if ((tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.h66()) == null) {
      // Inline function 'androidx.compose.ui.geometry.isSpecified' call
      var this_0 = this.dmd_1;
      tmp_1 = !equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0_safe_receiver_0 = this.cmd_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        var tmp_2 = Companion_instance_1;
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_1 = this.dmd_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var tmp_3 = floatFromBits(bits);
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_2 = this.dmd_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(this_2);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var tmp$ret$9 = floatFromBits(bits_0);
        tmp0_safe_receiver_0.g66(tmp_2.d5u(0.0, 0.0, tmp_3, tmp$ret$9));
      }
    }
    this.emd_1 = Companion_getInstance_14().k5e_1;
    this.fmd_1 = 1.0;
    this.gmd_1 = null;
    this.hmd_1 = new DrawCache();
  }
  protoOf(SvgPainter).g6t = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = this.dmd_1;
    if (!equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344))) {
      tmp = Size__times_impl_fnp4nc(this.dmd_1, this.bmd_1.u5e());
    } else {
      tmp = Companion_getInstance_14().k5e_1;
    }
    return tmp;
  };
  protoOf(SvgPainter).h6t = function (alpha) {
    this.fmd_1 = alpha;
    return true;
  };
  protoOf(SvgPainter).i6t = function (colorFilter) {
    this.gmd_1 = colorFilter;
    return true;
  };
  protoOf(SvgPainter).f6t = function (_this__u8e3s4) {
    if (!equals(this.emd_1, _this__u8e3s4.o5d())) {
      var tmp = Companion_getInstance_7().x6g_1;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'kotlin.math.ceil' call
      var x = floatFromBits(bits);
      var tmp$ret$4 = Math.ceil(x);
      var tmp0 = numberToInt(tmp$ret$4);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'kotlin.math.ceil' call
      var x_0 = floatFromBits(bits_0);
      var tmp$ret$9 = Math.ceil(x_0);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = numberToInt(tmp$ret$9);
      var tmp$ret$11 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp_0 = _IntSize___init__impl__emcjft(tmp$ret$11);
      var tmp_1 = _this__u8e3s4.r6p();
      this.hmd_1.m9m(tmp, tmp_0, _this__u8e3s4, tmp_1, SvgPainter$onDraw$lambda(this));
    }
    this.hmd_1.n9m(_this__u8e3s4, this.fmd_1, this.gmd_1);
  };
  var org_jetbrains_compose_resources_WebResourcesConfiguration$stable;
  function WebResourcesConfiguration$getResourcePath$lambda(it) {
    return './' + it;
  }
  function WebResourcesConfiguration() {
    WebResourcesConfiguration_instance = this;
    var tmp = this;
    tmp.nm8_1 = WebResourcesConfiguration$getResourcePath$lambda;
  }
  var WebResourcesConfiguration_instance;
  function WebResourcesConfiguration_getInstance() {
    if (WebResourcesConfiguration_instance == null)
      new WebResourcesConfiguration();
    return WebResourcesConfiguration_instance;
  }
  function rememberResourceState(key1, key2, key3, getDefault, block, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(1947629696, $changed, -1, 'org.jetbrains.compose.resources.rememberResourceState (ResourceState.web.kt:52)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var environment = $composer_1.u31(this_0).fm1($composer_0, 0);
    // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
    var getContext = null;
    var $composer_2 = $composer_0;
    if (!((1 & 1) === 0)) {
      getContext = rememberResourceState$lambda;
    }
    var composer = $composer_2;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_2.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = createCompositionCoroutineScope(getContext(), composer);
      $composer_2.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var scope = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!($composer_0.k31(key1) | $composer_0.k31(key2)) | $composer_0.k31(key3)) | $composer_0.k31(environment));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var mutableState = mutableStateOf(getDefault());
      var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
      launch(scope, VOID, tmp_1, rememberResourceState$slambda_0(mutableState, block, environment, null));
      var value_0 = mutableState;
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp0 = tmp_0;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function rememberResourceState_0(key1, getDefault, block, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(1147816128, $changed, -1, 'org.jetbrains.compose.resources.rememberResourceState (ResourceState.web.kt:15)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var environment = $composer_1.u31(this_0).fm1($composer_0, 0);
    // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
    var getContext = null;
    var $composer_2 = $composer_0;
    if (!((1 & 1) === 0)) {
      getContext = rememberResourceState$lambda_0;
    }
    var composer = $composer_2;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_2.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = createCompositionCoroutineScope(getContext(), composer);
      $composer_2.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var scope = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!($composer_0.k31(key1) | $composer_0.k31(environment));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var mutableState = mutableStateOf(getDefault());
      var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
      launch(scope, VOID, tmp_1, rememberResourceState$slambda_2(mutableState, block, environment, null));
      var value_0 = mutableState;
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp0 = tmp_0;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function rememberResourceState_1(key1, key2, getDefault, block, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-649733984, $changed, -1, 'org.jetbrains.compose.resources.rememberResourceState (ResourceState.web.kt:33)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var environment = $composer_1.u31(this_0).fm1($composer_0, 0);
    // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
    var getContext = null;
    var $composer_2 = $composer_0;
    if (!((1 & 1) === 0)) {
      getContext = rememberResourceState$lambda_1;
    }
    var composer = $composer_2;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_2.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = createCompositionCoroutineScope(getContext(), composer);
      $composer_2.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var scope = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!($composer_0.k31(key1) | $composer_0.k31(key2)) | $composer_0.k31(environment));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var mutableState = mutableStateOf(getDefault());
      var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
      launch(scope, VOID, tmp_1, rememberResourceState$slambda_4(mutableState, block, environment, null));
      var value_0 = mutableState;
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp0 = tmp_0;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function rememberResourceState_2(key1, key2, key3, key4, getDefault, block, $composer, $changed) {
    var $composer_0 = $composer;
    if (isTraceInProgress()) {
      traceEventStart(-204199840, $changed, -1, 'org.jetbrains.compose.resources.rememberResourceState (ResourceState.web.kt:72)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalComposeEnvironment();
    var $composer_1 = $composer_0;
    var environment = $composer_1.u31(this_0).fm1($composer_0, 0);
    // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
    var getContext = null;
    var $composer_2 = $composer_0;
    if (!((1 & 1) === 0)) {
      getContext = rememberResourceState$lambda_2;
    }
    var composer = $composer_2;
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_2.i31();
    var tmp;
    if (false || it === Companion_getInstance().f30_1) {
      var value = createCompositionCoroutineScope(getContext(), composer);
      $composer_2.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var scope = tmp;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!($composer_0.k31(key1) | $composer_0.k31(key2)) | $composer_0.k31(key3)) | $composer_0.k31(key4)) | $composer_0.k31(environment));
    // Inline function 'kotlin.let' call
    var it_0 = $composer_0.i31();
    var tmp_0;
    if (invalid || it_0 === Companion_getInstance().f30_1) {
      var mutableState = mutableStateOf(getDefault());
      var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
      launch(scope, VOID, tmp_1, rememberResourceState$slambda_6(mutableState, block, environment, null));
      var value_0 = mutableState;
      $composer_0.j31(value_0);
      tmp_0 = value_0;
    } else {
      tmp_0 = it_0;
    }
    var tmp0 = tmp_0;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    return tmp0;
  }
  function rememberResourceState$lambda() {
    return EmptyCoroutineContext_getInstance();
  }
  function rememberResourceState$slambda($mutableState, $block, $environment, resultContinuation) {
    this.qmd_1 = $mutableState;
    this.rmd_1 = $block;
    this.smd_1 = $environment;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberResourceState$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberResourceState$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberResourceState$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.rmd_1(this.smd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.qmd_1.s21(ARGUMENT);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rememberResourceState$slambda).q24 = function ($this$launch, completion) {
    var i = new rememberResourceState$slambda(this.qmd_1, this.rmd_1, this.smd_1, completion);
    i.tmd_1 = $this$launch;
    return i;
  };
  function rememberResourceState$slambda_0($mutableState, $block, $environment, resultContinuation) {
    var i = new rememberResourceState$slambda($mutableState, $block, $environment, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function rememberResourceState$lambda_0() {
    return EmptyCoroutineContext_getInstance();
  }
  function rememberResourceState$slambda_1($mutableState, $block, $environment, resultContinuation) {
    this.cme_1 = $mutableState;
    this.dme_1 = $block;
    this.eme_1 = $environment;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberResourceState$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberResourceState$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberResourceState$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.dme_1(this.eme_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.cme_1.s21(ARGUMENT);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rememberResourceState$slambda_1).q24 = function ($this$launch, completion) {
    var i = new rememberResourceState$slambda_1(this.cme_1, this.dme_1, this.eme_1, completion);
    i.fme_1 = $this$launch;
    return i;
  };
  function rememberResourceState$slambda_2($mutableState, $block, $environment, resultContinuation) {
    var i = new rememberResourceState$slambda_1($mutableState, $block, $environment, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function rememberResourceState$lambda_1() {
    return EmptyCoroutineContext_getInstance();
  }
  function rememberResourceState$slambda_3($mutableState, $block, $environment, resultContinuation) {
    this.ome_1 = $mutableState;
    this.pme_1 = $block;
    this.qme_1 = $environment;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberResourceState$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberResourceState$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberResourceState$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.pme_1(this.qme_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.ome_1.s21(ARGUMENT);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rememberResourceState$slambda_3).q24 = function ($this$launch, completion) {
    var i = new rememberResourceState$slambda_3(this.ome_1, this.pme_1, this.qme_1, completion);
    i.rme_1 = $this$launch;
    return i;
  };
  function rememberResourceState$slambda_4($mutableState, $block, $environment, resultContinuation) {
    var i = new rememberResourceState$slambda_3($mutableState, $block, $environment, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function rememberResourceState$lambda_2() {
    return EmptyCoroutineContext_getInstance();
  }
  function rememberResourceState$slambda_5($mutableState, $block, $environment, resultContinuation) {
    this.amf_1 = $mutableState;
    this.bmf_1 = $block;
    this.cmf_1 = $environment;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rememberResourceState$slambda_5).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(rememberResourceState$slambda_5).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rememberResourceState$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.bmf_1(this.cmf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.amf_1.s21(ARGUMENT);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(rememberResourceState$slambda_5).q24 = function ($this$launch, completion) {
    var i = new rememberResourceState$slambda_5(this.amf_1, this.bmf_1, this.cmf_1, completion);
    i.dmf_1 = $this$launch;
    return i;
  };
  function rememberResourceState$slambda_6($mutableState, $block, $environment, resultContinuation) {
    var i = new rememberResourceState$slambda_5($mutableState, $block, $environment, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  var org_jetbrains_compose_resources_ResourceWebCache$stable;
  function _get_supportsCacheApi__uddvv5($this) {
    var tmp0 = $this.uma_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('supportsCacheApi', 1, tmp, ResourceWebCache$_get_supportsCacheApi_$ref_d8lbja(), null);
    return tmp0.u1();
  }
  function isNewSession($this) {
    return !$this.vma_1;
  }
  function ResourceWebCache$supportsCacheApi$delegate$lambda() {
    return supportsCacheApi() && isCacheableProtocol();
  }
  function ResourceWebCache$_get_supportsCacheApi_$ref_d8lbja() {
    return constructCallableReference(function (p0) {
      return _get_supportsCacheApi__uddvv5(p0);
    }, 1, 0, 388);
  }
  function $loadCOROUTINE$(_this__u8e3s4, path, onNoCacheHit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mmf_1 = _this__u8e3s4;
    this.nmf_1 = path;
    this.omf_1 = onNoCacheHit;
  }
  protoOf($loadCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 20;
            if (!_get_supportsCacheApi__uddvv5(this.mmf_1)) {
              this.n9_1 = 19;
              suspendResult = this.omf_1(this.nmf_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            if (isNewSession(this.mmf_1)) {
              this.qmf_1 = this.mmf_1.tma_1;
              this.pmf_1 = null;
              this.n9_1 = 2;
              suspendResult = this.qmf_1.o2u(this.pmf_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 2:
            this.xmf_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 18;
            if (isNewSession(ResourceWebCache_getInstance())) {
              ResourceWebCache_getInstance().vma_1 = true;
              this.n9_1 = 4;
              suspendResult = ResourceWebCache_getInstance().ymf(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.xmf_1 = Unit_instance;
            this.o9_1 = 20;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.xmf_1;
            this.o9_1 = 20;
            this.qmf_1.q2u(this.pmf_1);
            this.n9_1 = 7;
            continue $sm;
          case 7:
            var tmp0 = this.mmf_1.sma_1;
            var key = this.nmf_1;
            var value = tmp0.w2(key);
            var tmp_0;
            if (value == null) {
              var answer = Mutex();
              tmp0.z2(key, answer);
              tmp_0 = answer;
            } else {
              tmp_0 = value;
            }

            var mutex = tmp_0;
            this.smf_1 = mutex;
            this.rmf_1 = null;
            this.n9_1 = 8;
            suspendResult = this.smf_1.o2u(this.rmf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.tmf_1 = Unit_instance;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.o9_1 = 17;
            this.n9_1 = 10;
            suspendResult = await_1(window.caches.open('compose_web_resources_cache'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.wmf_1 = suspendResult;
            this.n9_1 = 11;
            var cacheName = get_undefined();
            var o = {};
            o['ignoreSearch'] = false;
            o['ignoreMethod'] = false;
            o['ignoreVary'] = false;
            o['cacheName'] = cacheName;
            var tmp_1 = this.wmf_1.match(this.nmf_1, (!(o == null) ? !(o == null) : false) ? o : THROW_CCE());
            suspendResult = await_1(tmp_1 instanceof Promise ? tmp_1 : THROW_CCE(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            var response = suspendResult;
            var tmp1_elvis_lhs = response == null ? null : response.clone();
            if (tmp1_elvis_lhs == null) {
              this.n9_1 = 12;
              suspendResult = this.omf_1(this.nmf_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.umf_1 = tmp1_elvis_lhs;
              this.n9_1 = 15;
              continue $sm;
            }

          case 12:
            this.vmf_1 = suspendResult;
            var it = this.vmf_1;
            if (it.ok) {
              this.n9_1 = 13;
              suspendResult = await_1(this.wmf_1.put(this.nmf_1, it.clone()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 14;
              continue $sm;
            }

          case 13:
            this.n9_1 = 14;
            continue $sm;
          case 14:
            this.umf_1 = this.vmf_1;
            this.n9_1 = 15;
            continue $sm;
          case 15:
            this.tmf_1 = this.umf_1;
            this.o9_1 = 20;
            this.n9_1 = 16;
            continue $sm;
          case 16:
            var tmp_2 = this.tmf_1;
            this.o9_1 = 20;
            this.smf_1.q2u(this.rmf_1);
            ResourceWebCache_getInstance().sma_1.a3(this.nmf_1);
            return tmp_2;
          case 17:
            this.o9_1 = 20;
            var t = this.q9_1;
            this.smf_1.q2u(this.rmf_1);
            throw t;
          case 18:
            this.o9_1 = 20;
            var t_0 = this.q9_1;
            this.qmf_1.q2u(this.pmf_1);
            throw t_0;
          case 19:
            return suspendResult;
          case 20:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 20) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $resetCacheCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hmg_1 = _this__u8e3s4;
  }
  protoOf($resetCacheCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = await_1(window.caches.delete('compose_web_resources_cache'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ResourceWebCache() {
    ResourceWebCache_instance = this;
    this.rma_1 = 'compose_web_resources_cache';
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.sma_1 = LinkedHashMap_init_$Create$();
    this.tma_1 = Mutex();
    var tmp_0 = this;
    tmp_0.uma_1 = lazy(ResourceWebCache$supportsCacheApi$delegate$lambda);
    this.vma_1 = false;
  }
  protoOf(ResourceWebCache).wma = function (path, onNoCacheHit, $completion) {
    var tmp = new $loadCOROUTINE$(this, path, onNoCacheHit, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ResourceWebCache).ymf = function ($completion) {
    var tmp = new $resetCacheCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  var ResourceWebCache_instance;
  function ResourceWebCache_getInstance() {
    if (ResourceWebCache_instance == null)
      new ResourceWebCache();
    return ResourceWebCache_instance;
  }
  function supportsCacheApi() {
    return Boolean(window.caches);
  }
  function isCacheableProtocol() {
    return startsWith(window.location.protocol, 'http');
  }
  function await_1(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var tmp = await$lambda(cancellable);
    _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
    return cancellable.x1b();
  }
  function await$lambda($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      $continuation.y9(tmp$ret$0);
      return null;
    };
  }
  function await$lambda_0($continuation) {
    return function (it) {
      // Inline function 'kotlin.js.asJsException' call
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(it));
      this_0.y9(tmp$ret$2);
      return null;
    };
  }
  //region block: init
  org_jetbrains_compose_resources_FontResource$stable = 0;
  org_jetbrains_compose_resources_PluralStringResource$stable = 0;
  org_jetbrains_compose_resources_LanguageQualifier$stable = 0;
  org_jetbrains_compose_resources_RegionQualifier$stable = 0;
  Companion_instance_3 = new Companion();
  Companion_instance_4 = new Companion_0();
  org_jetbrains_compose_resources_Resource$stable = 0;
  org_jetbrains_compose_resources_ResourceItem$stable = 0;
  org_jetbrains_compose_resources_AsyncCache$stable = 8;
  org_jetbrains_compose_resources_ResourceCaches$stable = 8;
  org_jetbrains_compose_resources_StringArrayResource$stable = 0;
  org_jetbrains_compose_resources_StringResource$stable = 0;
  Companion_instance_5 = new Companion_1();
  org_jetbrains_compose_resources_plural_PluralRuleParseException$stable = 8;
  org_jetbrains_compose_resources_plural_PluralRule_Condition_And$stable = 0;
  org_jetbrains_compose_resources_plural_PluralRule_Condition_Or$stable = 0;
  org_jetbrains_compose_resources_plural_PluralRule_Condition_Relation$stable = 8;
  org_jetbrains_compose_resources_plural_PluralRule$stable = 0;
  org_jetbrains_compose_resources_plural_PluralRuleList$stable = 8;
  org_jetbrains_compose_resources_vector_xmldom_MalformedXMLException$stable = 8;
  org_jetbrains_compose_resources_Intl_Locale$stable = 0;
  org_jetbrains_compose_resources_DefaultJsResourceReader$stable = 0;
  TestJsResourceReader_instance = new TestJsResourceReader();
  DefaultJsResourceReader_instance = new DefaultJsResourceReader();
  org_jetbrains_compose_resources_vector_xmldom_ElementImpl$stable = 8;
  org_jetbrains_compose_resources_vector_xmldom_NodeImpl$stable = 8;
  org_jetbrains_compose_resources_DrawCache$stable = 8;
  org_jetbrains_compose_resources_SvgElement$stable = 8;
  org_jetbrains_compose_resources_SvgPainter$stable = 8;
  org_jetbrains_compose_resources_WebResourcesConfiguration$stable = 8;
  org_jetbrains_compose_resources_ResourceWebCache$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = getString_0;
  _.$_$.b = getString;
  _.$_$.c = DrawableResource;
  _.$_$.d = FontResource;
  _.$_$.e = Font_0;
  _.$_$.f = LanguageQualifier;
  _.$_$.g = ResourceItem;
  _.$_$.h = StringResource;
  _.$_$.i = painterResource;
  _.$_$.j = stringResource;
  _.$_$.k = stringResource_0;
  //endregion
  return _;
}));

//# sourceMappingURL=components-resources-library.js.map
